export default [
  {
    iso3: 'VAT',
    iso: '',
    country_code: 336,
    idmc_short_name: 'Holy See',
    idmc_full_name: 'Holy See',
    name: 'Holy See',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: '',
    centroid: [30.035123, -95.8116],
    boundingbox: [30.032704, 30.036811, -95.811604, -95.811407],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Ciudad del Vaticano',
    idmc_short_name_fr: 'Â Saint-SiÃ¨ge(Ãtat de la CitÃ© du Vatican)',
    idmc_short_name_ar: 'Â Â Ø§ÙÙØ§ØªÙÙØ§Ù',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'TKL',
    iso: '',
    country_code: 772,
    idmc_short_name: 'Tokelau',
    idmc_full_name: 'Tokelau',
    name: 'Tokelau',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-9.1676396, -171.8196878],
    boundingbox: [-9.6442499, -8.3328631, -172.7213673, -170.9797586],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Tokelau',
    idmc_short_name_fr: 'Â Tokelau',
    idmc_short_name_ar: 'Â ØªÙÙÙÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'SHN',
    iso: '',
    country_code: 654,
    idmc_short_name: 'Saint Helena',
    idmc_full_name: 'Saint Helena',
    name: 'Saint Helena',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [-15.9686862, -5.7129557],
    boundingbox: [-16.23, -15.704, -5.9973424, -5.4234153],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Santa Elena',
    idmc_short_name_fr: 'Â Sainte-HÃ©lÃ¨ne, Ascension et Tristan da Cunha',
    idmc_short_name_ar:
      'Â Ø³Ø§ÙØª ÙÙÙØ§ÙØ© ÙØ£Ø³ÙÙØ´ÙÙ ÙØªØ±ÙØ³ØªØ§Ù Ø¯Ø§ ÙÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SJM',
    iso: '',
    country_code: 744,
    idmc_short_name: 'Svalbard and Jan Mayen Islands',
    idmc_full_name: 'Svalbard and Jan Mayen Islands',
    name: 'Svalbard and Jan Mayen Islands',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: '',
    centroid: [79.3164454, 19.6842944],
    boundingbox: [78.9964454, 79.6364454, 19.3642944, 20.0042944],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Svalbard y Jan Mayen',
    idmc_short_name_fr: 'Â Svalbard et ile Jan Mayen',
    idmc_short_name_ar: 'Â Ø³ÙØ§ÙØ¨Ø§Ø±Ø¯ ÙÙØ§Ù ÙØ§ÙÙ',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'NFK',
    iso: '',
    country_code: 574,
    idmc_short_name: 'Norfolk Island',
    idmc_full_name: 'Norfolk Island',
    name: 'Norfolk Island',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-29.0328038, 167.9483137],
    boundingbox: [-29.3370694, -28.7936626, 167.6856728, 168.2261259],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Norkfolk',
    idmc_short_name_fr: 'Â Ãle Norfolk',
    idmc_short_name_ar: 'Â Ø¬Ø²ÙØ±Ø© ÙÙØ±ÙÙÙÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'MYT',
    iso: '',
    country_code: 175,
    idmc_short_name: 'Mayotte',
    idmc_full_name: 'Mayotte',
    name: 'Mayotte',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-12.823048, 45.1520755],
    boundingbox: [-13.0210119, -12.6365902, 45.0183298, 45.2999917],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Mayotte',
    idmc_short_name_fr: 'Â Mayotte',
    idmc_short_name_ar: 'Â ÙØ§ÙÙØª',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'REU',
    iso: '',
    country_code: 638,
    idmc_short_name: 'RÃ©union',
    idmc_full_name: 'RÃ©union',
    name: 'RÃ©union',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-21.1309332, 55.5265771],
    boundingbox: [-21.3897308, -20.8717136, 55.2164268, 55.8366924],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'ReuniÃ³n',
    idmc_short_name_fr: 'Â La RÃ©union',
    idmc_short_name_ar: 'Â ÙØ§ Ø±ÙÙÙÙÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'GIB',
    iso: 'GI',
    country_code: 292,
    idmc_short_name: 'Gibraltar',
    idmc_full_name: 'Gibraltar',
    name: 'Gibraltar',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: '',
    centroid: [36.140807, -5.3541295],
    boundingbox: [36.100807, 36.180807, -5.3941295, -5.3141295],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Gibraltar',
    idmc_short_name_fr: 'Â Gibraltar',
    idmc_short_name_ar: 'Â Ø¬Ø¨Ù Ø·Ø§Ø±Ù',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'NIU',
    iso: '',
    country_code: 570,
    idmc_short_name: 'Niue',
    idmc_full_name: 'Niue',
    name: 'Niue',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-19.0536414, -169.8613411],
    boundingbox: [-19.3548665, -18.7534559, -170.1595029, -169.5647229],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Niue',
    idmc_short_name_fr: 'Â Niue',
    idmc_short_name_ar: 'Â ÙÙÙÙÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'WLF',
    iso: '',
    country_code: 876,
    idmc_short_name: 'Wallis and Futuna Islands',
    idmc_full_name: 'Wallis and Futuna Islands',
    name: 'Wallis and Futuna Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-13.8173324, -177.1489649],
    boundingbox: [-14.5630748, -12.9827961, -178.3873749, -175.9190391],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Wallis y Futuna',
    idmc_short_name_fr: 'Â Wallis-et-Futuna',
    idmc_short_name_ar: 'Â ÙØ§ÙØ³ ÙÙÙØªÙÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'BEN',
    iso: 'BJ',
    country_code: 204,
    idmc_short_name: 'Benin',
    idmc_full_name: 'Benin',
    name: 'Benin',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [10.876464994816295, 2.724609375],
    boundingbox: [6.0398696, 0.776667, 12.4092447, 3.843343],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Benin',
    idmc_short_name_fr: 'Â BÃ©nin',
    idmc_short_name_ar: 'Â Ø¨ÙÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'PCN',
    iso: '',
    country_code: 612,
    idmc_short_name: 'Pitcairn',
    idmc_full_name: 'Pitcairn',
    name: 'Pitcairn',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-25.0657719, -130.1017823],
    boundingbox: [-25.1306736, -23.8655769, -130.8049862, -124.717534],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Pitcairn',
    idmc_short_name_fr: 'Â Ãles Pitcairn',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø¨ÙØªÙÙØ±Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'TZA',
    iso: 'TZ',
    country_code: 834,
    idmc_short_name: 'Tanzania',
    idmc_full_name: 'United Republic of Tanzania',
    name: 'Tanzania',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-6.2627301, 34.823101],
    boundingbox: [
      -11.845847044118484,
      28.98193359375,
      -0.615222552406841,
      40.49560546875,
    ],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'Tanzania',
    idmc_short_name_fr: 'Â Tanzanie',
    idmc_short_name_ar: 'Â ØªÙØ²Ø§ÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'HMD',
    iso: '',
    country_code: 334,
    idmc_short_name: 'Heard Island and McDonald Islands',
    idmc_full_name: 'Heard Island and McDonald Islands',
    name: 'Heard Island and McDonald Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-53.0166353, 72.955751],
    boundingbox: [-53.394703, -52.7031304, 72.2461932, 74.2045345],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Heard y McDonald',
    idmc_short_name_fr: 'Â Ãles Heard-et-MacDonald',
    idmc_short_name_ar: 'Â Ø¬Ø²ÙØ±Ø© ÙÙØ±Ø¯ ÙØ¬Ø²Ø± ÙØ§ÙØ¯ÙÙØ§ÙØ¯',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'ATA',
    iso: '',
    country_code: 10,
    idmc_short_name: 'Antarctica',
    idmc_full_name: 'Antarctica',
    name: 'Antarctica',
    geographical_group: 'Antarctica',
    region: 'Antarctica',
    sub_region: '',
    centroid: [-79.4063075, 0.3149312],
    boundingbox: [-85.0511287, -60, -180, 180],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'AntÃ¡rtida',
    idmc_short_name_fr: 'Â Antarctique',
    idmc_short_name_ar: 'Â Ø§ÙÙØ§Ø±Ø© Ø§ÙÙØ·Ø¨ÙØ© Ø§ÙØ¬ÙÙØ¨ÙØ©',
    geographical_group_grid: 'Antarctica',
  },
  {
    iso3: 'UMI',
    iso: '',
    country_code: 581,
    idmc_short_name: 'United States Minor Outlying Islands',
    idmc_full_name: 'United States Minor Outlying Islands',
    name: 'United States Minor Outlying Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [6.4295092, -162.407309978782],
    boundingbox: [6.1779744, 6.6514388, -162.6816297, -162.1339885],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Ultramarinas Menores de Estados Unidos',
    idmc_short_name_fr: 'Â Ãles mineures Ã©loignÃ©es des Ãtats-Unis',
    idmc_short_name_ar:
      'Â Ø¬Ø²Ø± Ø§ÙÙÙØ§ÙØ§Øª Ø§ÙÙØªØ­Ø¯Ø© Ø§ÙØµØºÙØ±Ø© Ø§ÙÙØ§Ø¦ÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'CCK',
    iso: '',
    country_code: 166,
    idmc_short_name: 'Cocos (Keeling) Islands',
    idmc_full_name: 'Cocos (Keeling) Islands',
    name: 'Cocos (Keeling) Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: '',
    centroid: [-12.0159512, 96.8577773312584],
    boundingbox: [-12.4118829, -11.6212366, 96.6115772, 97.1349614],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Cocos',
    idmc_short_name_fr: 'Â Ãles Cocos',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙÙÙÙØ³',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'AFG',
    iso: 'AF',
    country_code: 4,
    idmc_short_name: 'Afghanistan',
    idmc_full_name: 'Afghanistan',
    name: 'Afghanistan',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [33.7680065, 66.2385139],
    boundingbox: [29.3772, 60.5176034, 38.4910682, 74.889862],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'AfganistÃ¡n',
    idmc_short_name_fr: 'Â Afghanistan',
    idmc_short_name_ar: 'Â Ø£ÙØºØ§ÙØ³ØªØ§Ù',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'ALB',
    iso: 'AL',
    country_code: 8,
    idmc_short_name: 'Albania',
    idmc_full_name: 'Albania',
    name: 'Albania',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [41.000028, 19.9999619],
    boundingbox: [39.6448625, 19.1246095, 42.6610848, 21.0574335],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Albania',
    idmc_short_name_fr: 'Â Albanie',
    idmc_short_name_ar: 'Â Ø£ÙØ¨Ø§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'ASM',
    iso: 'AS',
    country_code: 16,
    idmc_short_name: 'American Samoa',
    idmc_full_name: 'American Samoa',
    name: 'American Samoa',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Polynesia',
    centroid: [-14.30063095, -170.695974791655],
    boundingbox: [-14.7608358, -171.2951296, -10.8449746, -167.9322899],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Samoa Americana',
    idmc_short_name_fr: 'Â Samoa amÃ©ricaines',
    idmc_short_name_ar: 'Â Ø³Ø§ÙÙØ§ Ø§ÙØ£ÙØ±ÙÙÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'AND',
    iso: 'AD',
    country_code: 20,
    idmc_short_name: 'Andorra',
    idmc_full_name: 'Andorra',
    name: 'Andorra',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [42.5407167, 1.5732033],
    boundingbox: [42.4288238, 1.4135781, 42.6559357, 1.7863837],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Andorra',
    idmc_short_name_fr: 'Â Andorre',
    idmc_short_name_ar: 'Â Ø£ÙØ¯ÙØ±Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'ARM',
    iso: 'AM',
    country_code: 51,
    idmc_short_name: 'Armenia',
    idmc_full_name: 'Armenia',
    name: 'Armenia',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [40.070113, 45.200272],
    boundingbox: [38.8404775, 43.4471395, 41.300712, 46.6333087],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Armenia',
    idmc_short_name_fr: 'Â ArmÃ©nie',
    idmc_short_name_ar: 'Â Ø£Ø±ÙÙÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'AUS',
    iso: 'AU',
    country_code: 36,
    idmc_short_name: 'Australia',
    idmc_full_name: 'Australia',
    name: 'Australia',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Australia and New Zealand',
    centroid: [-24.7761086, 134.755],
    boundingbox: [-55.3228175, 72.2460938, -9.0882278, 168.2249543],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Australia',
    idmc_short_name_fr: 'Â Australie',
    idmc_short_name_ar: 'Â Ø£Ø³ØªØ±Ø§ÙÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'AUT',
    iso: 'AT',
    country_code: 40,
    idmc_short_name: 'Austria',
    idmc_full_name: 'Austria',
    name: 'Austria',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [47.2000338, 13.199959],
    boundingbox: [46.3722761, 9.5307487, 49.0205305, 17.160776],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Austria',
    idmc_short_name_fr: 'Â Autriche',
    idmc_short_name_ar: 'Â Ø§ÙÙÙØ³Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'AZE',
    iso: 'AZ',
    country_code: 31,
    idmc_short_name: 'Azerbaijan',
    idmc_full_name: 'Azerbaijan',
    name: 'Azerbaijan',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [40.3936294, 47.7872508],
    boundingbox: [38.3929551, 44.7633701, 41.9502947, 51.0090302],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'AzerbaiyÃ¡n',
    idmc_short_name_fr: 'Â AzerbaÃ¯djan',
    idmc_short_name_ar: 'Â Ø£Ø°Ø±Ø¨ÙØ¬Ø§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'BHR',
    iso: 'BH',
    country_code: 48,
    idmc_short_name: 'Bahrain',
    idmc_full_name: 'Bahrain',
    name: 'Bahrain',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [26.1551249, 50.5344606],
    boundingbox: [25.535, 50.2697989, 26.6872444, 50.9233693],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'BahrÃ©in',
    idmc_short_name_fr: 'Â BahreÃ¯n',
    idmc_short_name_ar: 'Â Ø§ÙØ¨Ø­Ø±ÙÙ',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'BGD',
    iso: 'BD',
    country_code: 50,
    idmc_short_name: 'Bangladesh',
    idmc_full_name: 'Bangladesh',
    name: 'Bangladesh',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [24.4768783, 90.2932426],
    boundingbox: [20.3756582, 88.0075306, 26.6382534, 92.6804979],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bangladesh',
    idmc_short_name_fr: 'Â Bangladesh',
    idmc_short_name_ar: 'Â Ø¨ÙØºÙØ§Ø¯ÙØ´',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'BLR',
    iso: 'BY',
    country_code: 112,
    idmc_short_name: 'Belarus',
    idmc_full_name: 'Belarus',
    name: 'Belarus',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [53.4250605, 27.6971358],
    boundingbox: [51.2575982, 23.1783344, 56.17218, 32.7627809],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'BelarÃºs',
    idmc_short_name_fr: 'Â BiÃ©lorussie',
    idmc_short_name_ar: 'Â Ø±ÙØ³ÙØ§ Ø§ÙØ¨ÙØ¶Ø§Ø¡',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'BEL',
    iso: 'BE',
    country_code: 56,
    idmc_short_name: 'Belgium',
    idmc_full_name: 'Belgium',
    name: 'Belgium',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [50.875311142200765, 4.3780517578125],
    boundingbox: [49.4969821, 2.3889137, 51.5516667, 6.408097],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'BÃ©lgica',
    idmc_short_name_fr: 'Â Belgique',
    idmc_short_name_ar: 'Â Ø¨ÙØ¬ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'BTN',
    iso: 'BT',
    country_code: 64,
    idmc_short_name: 'Bhutan',
    idmc_full_name: 'Bhutan',
    name: 'Bhutan',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [27.549511, 90.5119273],
    boundingbox: [26.702016, 88.7464724, 28.246987, 92.1252321],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'BhutÃ¡n',
    idmc_short_name_fr: 'Â Bhoutan',
    idmc_short_name_ar: 'Â Ø¨ÙØªØ§Ù',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'BIH',
    iso: 'BA',
    country_code: 70,
    idmc_short_name: 'Bosnia and Herzegovina',
    idmc_full_name: 'Bosnia and Herzegovina',
    name: 'Bosnia and Herzegovina',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [44.08758502824516, 17.940673828125],
    boundingbox: [42.5553114, 15.7287433, 45.2764135, 19.6237311],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bosnia y Herzegovina',
    idmc_short_name_fr: 'Â Bosnie-HerzÃ©govine',
    idmc_short_name_ar: 'Â Ø§ÙØ¨ÙØ³ÙØ© ÙØ§ÙÙØ±Ø³Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'BMU',
    iso: 'BM',
    country_code: 60,
    idmc_short_name: 'Bermuda',
    idmc_full_name: 'Bermuda',
    name: 'Bermuda',
    geographical_group: 'North America',
    region: 'Americas',
    sub_region: 'Northern America',
    centroid: [32.3018217, -64.7603583],
    boundingbox: [32.0469651, -65.1232222, 32.5913693, -64.4109842],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bermudas',
    idmc_short_name_fr: 'Â Bermudes',
    idmc_short_name_ar: 'Â Ø¨Ø±ÙÙØ¯Ø§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'XKX',
    iso: '',
    country_code: 0,
    idmc_short_name: 'Kosovo',
    idmc_full_name: 'Kosovo',
    name: 'Kosovo',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [42.5869578, 20.9021231],
    boundingbox: [41.8577007, 20.0140589, 43.2674604, 21.7894228],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Kosovo',
    idmc_short_name_fr: 'Kosovo',
    idmc_short_name_ar: 'ÙÙØ³ÙÙÙ',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'ESH',
    iso: '',
    country_code: 732,
    idmc_short_name: 'Western Sahara',
    idmc_full_name: 'Western Sahara',
    name: 'Western Sahara',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: '',
    centroid: [24.1797324, -13.7667848],
    boundingbox: [20.556883, 27.6666834, -17.3494721, -8.666389],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'North',
    idmc_short_name_es: 'Sahara Occidental',
    idmc_short_name_fr: 'Â RÃ©publique arabe sahraouie dÃ©mocratique',
    idmc_short_name_ar: 'Â Ø§ÙØµØ­Ø±Ø§Ø¡ Ø§ÙØºØ±Ø¨ÙØ©',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'AGO',
    iso: 'AO',
    country_code: 24,
    idmc_short_name: 'Angola',
    idmc_full_name: 'Angola',
    name: 'Angola',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [-11.8775768, 17.5691241],
    boundingbox: [-18.038945, 11.4609793, -4.3880634, 24.0878856],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'South',
    idmc_short_name_es: 'Angola',
    idmc_short_name_fr: 'Â Angola',
    idmc_short_name_ar: 'Â Ø£ÙØºÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'BWA',
    iso: 'BW',
    country_code: 72,
    idmc_short_name: 'Botswana',
    idmc_full_name: 'Botswana',
    name: 'Botswana',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Southern Africa',
    centroid: [-23.1681782, 24.5928742],
    boundingbox: [-26.9059669, 19.9986474, -17.778137, 29.375304],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'South',
    idmc_short_name_es: 'Botsuana',
    idmc_short_name_fr: 'Â Botswana',
    idmc_short_name_ar: 'Â Ø¨ÙØªØ³ÙØ§ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'BRN',
    iso: 'BN',
    country_code: 96,
    idmc_short_name: 'Brunei',
    idmc_full_name: 'Brunei Darussalam',
    name: 'Brunei Darussalam',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [4.4137155, 114.5653908],
    boundingbox: [4.002508, 114.076123, 5.1011857, 115.3635623],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'BrunÃ©i',
    idmc_short_name_fr: 'Â Brunei',
    idmc_short_name_ar: 'Â Ø¨Ø±ÙÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'BGR',
    iso: 'BG',
    country_code: 100,
    idmc_short_name: 'Bulgaria',
    idmc_full_name: 'Bulgaria',
    name: 'Bulgaria',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [42.6073975, 25.4856617],
    boundingbox: [41.2353929, 22.3571459, 44.2162875, 28.8875409],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bulgaria',
    idmc_short_name_fr: 'Â Bulgarie',
    idmc_short_name_ar: 'Â Ø¨ÙØºØ§Ø±ÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'KHM',
    iso: 'KH',
    country_code: 116,
    idmc_short_name: 'Cambodia',
    idmc_full_name: 'Cambodia',
    name: 'Cambodia',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [13.5066394, 104.869423],
    boundingbox: [9.4752639, 102.3338282, 14.6902471, 107.6276788],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Camboya',
    idmc_short_name_fr: 'Â Cambodge',
    idmc_short_name_ar: 'Â ÙÙØ¨ÙØ¯ÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'COK',
    iso: '',
    country_code: 184,
    idmc_short_name: 'Cook Islands',
    idmc_full_name: 'Cook Islands',
    name: 'Cook Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Polynesia',
    centroid: [-16.0492781, -160.3554851],
    boundingbox: [-22.15807, -166.0856468, -8.7168792, -157.1089329],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Cook',
    idmc_short_name_fr: 'Â Ãles Cook',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙÙÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'HRV',
    iso: 'HR',
    country_code: 191,
    idmc_short_name: 'Croatia',
    idmc_full_name: 'Croatia',
    name: 'Croatia',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [45.5643442, 17.0118954],
    boundingbox: [42.1765993, 13.2104814, 46.555029, 19.4470842],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Croacia',
    idmc_short_name_fr: 'Â Croatie',
    idmc_short_name_ar: 'Â ÙØ±ÙØ§ØªÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'CYP',
    iso: 'CY',
    country_code: 196,
    idmc_short_name: 'Cyprus',
    idmc_full_name: 'Cyprus',
    name: 'Cyprus',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [34.9823018, 33.1451285],
    boundingbox: [27.4823018, 25.6451285, 42.4823018, 40.6451285],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Chipre',
    idmc_short_name_fr: 'Â Chypre(pays)',
    idmc_short_name_ar: 'Â ÙØ¨Ø±Øµ',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'CZE',
    iso: 'CZ',
    country_code: 203,
    idmc_short_name: 'Czech Republic',
    idmc_full_name: 'Czechia',
    name: 'Czech Republic',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [49.8167003, 15.4749544],
    boundingbox: [48.5518083, 12.0905901, 51.0557036, 18.859216],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'RepÃºblica Checa',
    idmc_short_name_fr: 'Â TchÃ©quie',
    idmc_short_name_ar: 'Â Ø¬ÙÙÙØ±ÙØ© Ø§ÙØªØ´ÙÙ',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'DNK',
    iso: 'DK',
    country_code: 208,
    idmc_short_name: 'Denmark',
    idmc_full_name: 'Denmark',
    name: 'Denmark',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [55.670249, 10.3333283],
    boundingbox: [54.4516667, 7.7153255, 57.9524297, 15.5530641],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Dinamarca',
    idmc_short_name_fr: 'Â Danemark',
    idmc_short_name_ar: 'Â Ø§ÙØ¯ÙÙØ§Ø±Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'CHN',
    iso: 'CN',
    country_code: 156,
    idmc_short_name: 'China',
    idmc_full_name: 'China',
    name: 'China',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [36.5694, 103.914],
    boundingbox: [
      17.5602465032949,
      71.279296875,
      56.022948079627454,
      140.80078125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'China',
    idmc_short_name_fr: 'Â Chine',
    idmc_short_name_ar: 'Â Ø§ÙØµÙÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'CHL',
    iso: 'CL',
    country_code: 152,
    idmc_short_name: 'Chile',
    idmc_full_name: 'Chile',
    name: 'Chile',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-31.7613365, -71.3187697],
    boundingbox: [
      -58.17070248348609,
      -96.240234375,
      -9.102096738726443,
      -50.80078125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Chile',
    idmc_short_name_fr: 'Â Chili',
    idmc_short_name_ar: 'Â ØªØ´ÙÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'CAN',
    iso: 'CA',
    country_code: 124,
    idmc_short_name: 'Canada',
    idmc_full_name: 'Canada',
    name: 'Canada',
    geographical_group: 'North America',
    region: 'Americas',
    sub_region: 'Northern America',
    centroid: [61.0666922, -107.9917071],
    boundingbox: [41.6765556, -141.00275, 83.3362128, -52.3231981],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'CanadÃ¡',
    idmc_short_name_fr: 'Â Canada',
    idmc_short_name_ar: 'Â ÙÙØ¯Ø§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'AB9',
    iso: '',
    country_code: 0,
    idmc_short_name: 'Abyei Area',
    idmc_full_name: 'Abyei Area',
    name: 'Abyei Area',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [9.6044573, 28.4334735],
    boundingbox: [9.5644573, 28.3934735, 9.6444573, 28.4734735],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'East',
    idmc_short_name_es: 'Abyei',
    idmc_short_name_fr: 'Abyei',
    idmc_short_name_ar: 'Ø£Ø¨ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'EST',
    iso: 'EE',
    country_code: 233,
    idmc_short_name: 'Estonia',
    idmc_full_name: 'Estonia',
    name: 'Estonia',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [58.7523778, 25.3319078],
    boundingbox: [57.5093124, 21.3826069, 59.9383754, 28.2100175],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Estonia',
    idmc_short_name_fr: 'Â Estonie',
    idmc_short_name_ar: 'Â Ø¥Ø³ØªÙÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'TCD',
    iso: 'TD',
    country_code: 148,
    idmc_short_name: 'Chad',
    idmc_full_name: 'Chad',
    name: 'Chad',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [15.6134137, 19.0156172],
    boundingbox: [7.44107, 13.47348, 23.4975, 24],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'Central',
    idmc_short_name_es: 'Chad',
    idmc_short_name_fr: 'Â Tchad',
    idmc_short_name_ar: 'Â ØªØ´Ø§Ø¯',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'CAF',
    iso: 'CF',
    country_code: 140,
    idmc_short_name: 'Central African Republic',
    idmc_full_name: 'Central African Republic',
    name: 'Central African Republic',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [7.0323598, 19.9981227],
    boundingbox: [2.2156553, 14.4155426, 11.001389, 27.4540764],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'Central',
    idmc_short_name_es: 'RepÃºblica Centro-Africana',
    idmc_short_name_fr: 'Â RÃ©publique centrafricaine',
    idmc_short_name_ar: 'Â Ø¬ÙÙÙØ±ÙØ© Ø£ÙØ±ÙÙÙØ§ Ø§ÙÙØ³Ø·Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'GNQ',
    iso: 'GQ',
    country_code: 226,
    idmc_short_name: 'Equatorial Guinea',
    idmc_full_name: 'Equatorial Guinea',
    name: 'Equatorial Guinea',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [1.613172, 10.5170357],
    boundingbox: [
      0.6756435204204166,
      8.997802734375,
      2.4601811810210052,
      11.5191650390625,
    ],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'Central',
    idmc_short_name_es: 'Guinea Ecuatorial',
    idmc_short_name_fr: 'Â GuinÃ©e Ã©quatoriale',
    idmc_short_name_ar: 'Â ØºÙÙÙØ§ Ø§ÙØ§Ø³ØªÙØ§Ø¦ÙØ©',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'CIV',
    iso: 'CI',
    country_code: 384,
    idmc_short_name: "CÃ´te d'Ivoire",
    idmc_full_name: "CÃ´te d'Ivoire",
    name: "CÃ´te d'Ivoire",
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [7.9897371, -5.5679458],
    boundingbox: [4.1621205, -8.601725, 10.740197, -2.493031],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Costa de Marfil',
    idmc_short_name_fr: "Â CÃ´te d'Ivoire",
    idmc_short_name_ar: 'Â Ø³Ø§Ø­Ù Ø§ÙØ¹Ø§Ø¬',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'BFA',
    iso: 'BF',
    country_code: 854,
    idmc_short_name: 'Burkina Faso',
    idmc_full_name: 'Burkina Faso',
    name: 'Burkina Faso',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [12.0753083, -1.6880314],
    boundingbox: [9.4104718, -5.5132416, 15.084, 2.4089717],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Burkina Faso',
    idmc_short_name_fr: 'Â Burkina Faso',
    idmc_short_name_ar: 'Â Ø¨ÙØ±ÙÙÙØ§ ÙØ§Ø³Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'ERI',
    iso: 'ER',
    country_code: 232,
    idmc_short_name: 'Eritrea',
    idmc_full_name: 'Eritrea',
    name: 'Eritrea',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [15.9500319, 37.9999668],
    boundingbox: [12.3548219, 36.4333653, 18.0709917, 43.3001714],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'Eritrea',
    idmc_short_name_fr: 'Â ÃrythrÃ©e',
    idmc_short_name_ar: 'Â Ø¥Ø±ÙØªØ±ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'ETH',
    iso: 'ET',
    country_code: 231,
    idmc_short_name: 'Ethiopia',
    idmc_full_name: 'Ethiopia',
    name: 'Ethiopia',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [10.2116702, 38.6521203],
    boundingbox: [3.397448, 32.9975838, 14.8944684, 47.9823797],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'EtiopÃ­a',
    idmc_short_name_fr: 'Â Ãthiopie',
    idmc_short_name_ar: 'Â Ø¥Ø«ÙÙØ¨ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'DJI',
    iso: 'DJ',
    country_code: 262,
    idmc_short_name: 'Djibouti',
    idmc_full_name: 'Djibouti',
    name: 'Djibouti',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [11.85677545, 42.7577845199437],
    boundingbox: [10.9149547, 41.7713139, 12.7923081, 43.6579046],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'East',
    idmc_short_name_es: 'Yibuti',
    idmc_short_name_fr: 'Â Djibouti',
    idmc_short_name_ar: 'Â Ø¬ÙØ¨ÙØªÙ',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'COM',
    iso: 'KM',
    country_code: 174,
    idmc_short_name: 'Comoros',
    idmc_full_name: 'Comoros',
    name: 'Comoros',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-12.2045176, 44.2832964],
    boundingbox: [-12.621, 43.025305, -11.165, 44.7451922],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'Comoros',
    idmc_short_name_fr: 'Â Comores(pays)',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø§ÙÙÙØ±',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'COG',
    iso: 'CG',
    country_code: 178,
    idmc_short_name: 'Congo',
    idmc_full_name: 'Congo',
    name: 'Congo, Rep',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [-0.7264327, 15.6419155],
    boundingbox: [-5.149089, 11.0048205, 3.713056, 18.643611],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'Central',
    idmc_short_name_es: 'Congo',
    idmc_short_name_fr: 'Â RÃ©publique du Congo',
    idmc_short_name_ar: 'Â Ø¬ÙÙÙØ±ÙØ© Ø§ÙÙÙÙØºÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'CPV',
    iso: 'CV',
    country_code: 132,
    idmc_short_name: 'Cabo Verde',
    idmc_full_name: 'Cabo Verde',
    name: 'Cabo Verde',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [15.9424, -23.9795],
    boundingbox: [-21.589, -46.524, -21.378, -46.203576],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'West',
    idmc_short_name_es: 'Cabo Verde',
    idmc_short_name_fr: 'Â Cap-Vert',
    idmc_short_name_ar: 'Â Ø§ÙØ±Ø£Ø³ Ø§ÙØ£Ø®Ø¶Ø±',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'FRO',
    iso: 'FO',
    country_code: 234,
    idmc_short_name: 'Faroe Islands',
    idmc_full_name: 'Faroe Islands',
    name: 'Faeroe Islands',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [62.19850045, -6.81741243341217],
    boundingbox: [61.3915553, -7.6882939, 62.3938847, -6.2565525],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Faroe',
    idmc_short_name_fr: 'Â Ãles FÃ©roÃ©',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙØ§Ø±Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'FJI',
    iso: 'FJ',
    country_code: 242,
    idmc_short_name: 'Fiji',
    idmc_full_name: 'Fiji',
    name: 'Fiji',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Melanesia',
    centroid: [-18.1239696, 179.0122737],
    boundingbox: [
      -20.653346148076054,
      175.78125,
      -15.188783763403242,
      182.296142578125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Fiji',
    idmc_short_name_fr: 'Â Fidji',
    idmc_short_name_ar: 'Â ÙÙØ¬Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'FIN',
    iso: 'FI',
    country_code: 246,
    idmc_short_name: 'Finland',
    idmc_full_name: 'Finland',
    name: 'Finland',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [63.2467777, 25.9209164],
    boundingbox: [59.4541578, 19.0832098, 70.0922939, 31.5867071],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Finlandia',
    idmc_short_name_fr: 'Â Finlande',
    idmc_short_name_ar: 'Â ÙÙÙÙØ¯Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'FRA',
    iso: 'FR',
    country_code: 250,
    idmc_short_name: 'France',
    idmc_full_name: 'France',
    name: 'France',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [46.603354, 1.8883335],
    boundingbox: [41.2632185, -5.4534286, 51.268318, 9.8678344],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Francia',
    idmc_short_name_fr: 'Â France',
    idmc_short_name_ar: 'Â ÙØ±ÙØ³Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'PYF',
    iso: 'PF',
    country_code: 258,
    idmc_short_name: 'French Polynesia',
    idmc_full_name: 'French Polynesia',
    name: 'French Polynesia',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Polynesia',
    centroid: [-18.6243749, -144.6434898],
    boundingbox: [-28.0990232, -154.9360599, -7.6592173, -134.244799],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Polinesia Francesa',
    idmc_short_name_fr: 'Â PolynÃ©sie franÃ§aise',
    idmc_short_name_ar: 'Â Ø¨ÙÙÙÙØ²ÙØ§ Ø§ÙÙØ±ÙØ³ÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'GEO',
    iso: 'GE',
    country_code: 268,
    idmc_short_name: 'Georgia',
    idmc_full_name: 'Georgia',
    name: 'Georgia',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [42.448099, 42.982277],
    boundingbox: [41.0552922, 39.8844803, 43.5864294, 46.7365373],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Georgia',
    idmc_short_name_fr: 'Â GÃ©orgie(pays)',
    idmc_short_name_ar: 'Â Ø¬ÙØ±Ø¬ÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'DEU',
    iso: 'DE',
    country_code: 276,
    idmc_short_name: 'Germany',
    idmc_full_name: 'Germany',
    name: 'Germany',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [51.0834196, 10.4234469],
    boundingbox: [47.2701114, 5.8663153, 55.099161, 15.0419319],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Alemania',
    idmc_short_name_fr: 'Â Allemagne',
    idmc_short_name_ar: 'Â Ø£ÙÙØ§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'GRC',
    iso: 'GR',
    country_code: 300,
    idmc_short_name: 'Greece',
    idmc_full_name: 'Greece',
    name: 'Greece',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [38.9953683, 21.9877132],
    boundingbox: [34.7006096, 19.2477876, 41.7488862, 29.7296986],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Grecia',
    idmc_short_name_fr: 'Â GrÃ¨ce',
    idmc_short_name_ar: 'Â Ø§ÙÙÙÙØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'GRL',
    iso: 'GL',
    country_code: 304,
    idmc_short_name: 'Greenland',
    idmc_full_name: 'Greenland',
    name: 'Greenland',
    geographical_group: 'Europe and Central Asia',
    region: 'Americas',
    sub_region: 'Northern America',
    centroid: [77.6192349, -42.8125967],
    boundingbox: [59.515387, -74.1250416, 83.875172, -10.0288759],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Groenlandia',
    idmc_short_name_fr: 'Â Groenland',
    idmc_short_name_ar: 'Â Ø¬Ø±ÙÙÙØ§ÙØ¯',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'GUM',
    iso: 'GU',
    country_code: 316,
    idmc_short_name: 'Guam',
    idmc_full_name: 'Guam',
    name: 'Guam',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [13.444138, 144.733626445767],
    boundingbox: [13.182335, 144.563426, 13.706179, 145.009167],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Guam',
    idmc_short_name_fr: 'Â Guam',
    idmc_short_name_ar: 'Â ØºÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'HKG',
    iso: 'HK',
    country_code: 344,
    idmc_short_name: 'Hong Kong, China',
    idmc_full_name: 'China, Hong Kong Special Administrative Region',
    name: 'Hong Kong SAR, China',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [22.350627, 114.1849161],
    boundingbox: [22.1367222, 113.8171111, 22.5683333, 114.5024444],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Hong Kong',
    idmc_short_name_fr: 'Â Hong Kong',
    idmc_short_name_ar: 'Â ÙÙÙØº ÙÙÙØº',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'HUN',
    iso: 'HU',
    country_code: 348,
    idmc_short_name: 'Hungary',
    idmc_full_name: 'Hungary',
    name: 'Hungary',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [47.1817585, 19.5060937],
    boundingbox: [45.737128, 16.1138867, 48.585257, 22.8977094],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'HungrÃ­a',
    idmc_short_name_fr: 'Â Hongrie',
    idmc_short_name_ar: 'Â Ø§ÙÙØ¬Ø±',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'ISL',
    iso: 'IS',
    country_code: 352,
    idmc_short_name: 'Iceland',
    idmc_full_name: 'Iceland',
    name: 'Iceland',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [64.9841821, -18.1059013],
    boundingbox: [63.0859177, -25.0135069, 67.353, -12.8046162],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islandia',
    idmc_short_name_fr: 'Â Islande',
    idmc_short_name_ar: 'Â Ø¢ÙØ³ÙÙØ¯Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'IND',
    iso: 'IN',
    country_code: 356,
    idmc_short_name: 'India',
    idmc_full_name: 'India',
    name: 'India',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [22.3511148, 78.6677428],
    boundingbox: [6.5546079, 68.1113787, 35.6745457, 97.395561],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'India',
    idmc_short_name_fr: 'Â Inde',
    idmc_short_name_ar: 'Â Ø§ÙÙÙØ¯',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'IDN',
    iso: 'ID',
    country_code: 360,
    idmc_short_name: 'Indonesia',
    idmc_full_name: 'Indonesia',
    name: 'Indonesia',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [-4.7993356, 114.5632032],
    boundingbox: [-11.2085669, 94.7717124, 6.2744496, 141.0194444],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Indonesia',
    idmc_short_name_fr: 'Â IndonÃ©sie',
    idmc_short_name_ar: 'Â Ø¥ÙØ¯ÙÙÙØ³ÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'IRQ',
    iso: 'IQ',
    country_code: 368,
    idmc_short_name: 'Iraq',
    idmc_full_name: 'Iraq',
    name: 'Iraq',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [33.0955793, 44.1749775],
    boundingbox: [29.0612087, 38.7936719, 37.380932, 48.8412702],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Irak',
    idmc_short_name_fr: 'Â Irak',
    idmc_short_name_ar: 'Â Ø§ÙØ¹Ø±Ø§Ù',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'IRL',
    iso: 'IE',
    country_code: 372,
    idmc_short_name: 'Ireland',
    idmc_full_name: 'Ireland',
    name: 'Ireland',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [52.865196, -7.9794599],
    boundingbox: [51.222, -11.0133788, 55.636, -5.6582363],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Irlanda',
    idmc_short_name_fr: 'Â IrlandeÂ (pays)',
    idmc_short_name_ar: 'Â Ø£ÙØ±ÙÙØ¯Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'IMN',
    iso: 'IM',
    country_code: 833,
    idmc_short_name: 'Isle of Man',
    idmc_full_name: 'Isle of Man',
    name: 'Isle of Man',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [54.2358167, -4.51459874569825],
    boundingbox: [54.0539576, -4.7946845, 54.4178705, -4.3076853],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Isla de Man',
    idmc_short_name_fr: 'Â Ãle de Man',
    idmc_short_name_ar: 'Â Ø¬Ø²ÙØ±Ø© ÙØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'ISR',
    iso: 'IL',
    country_code: 376,
    idmc_short_name: 'Israel',
    idmc_full_name: 'Israel',
    name: 'Israel',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [30.401306519203583, 34.9365234375],
    boundingbox: [29.4533796, 34.2674994, 33.3356317, 35.8950234],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Israel',
    idmc_short_name_fr: 'Â IsraÃ«l',
    idmc_short_name_ar: 'Â Ø¥Ø³Ø±Ø§Ø¦ÙÙ',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'ITA',
    iso: 'IT',
    country_code: 380,
    idmc_short_name: 'Italy',
    idmc_full_name: 'Italy',
    name: 'Italy',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [42.6384261, 12.674297],
    boundingbox: [35.2889616, 6.6272658, 47.0921462, 18.7844746],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Italia',
    idmc_short_name_fr: 'Â Italie',
    idmc_short_name_ar: 'Â Ø¥ÙØ·Ø§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'JPN',
    iso: 'JP',
    country_code: 392,
    idmc_short_name: 'Japan',
    idmc_full_name: 'Japan',
    name: 'Japan',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [36.5748441, 139.2394179],
    boundingbox: [20.2145811, 122.7141754, 45.7112046, 154.205541],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'JapÃ³n',
    idmc_short_name_fr: 'Â Japon',
    idmc_short_name_ar: 'Â Ø§ÙÙØ§Ø¨Ø§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'JOR',
    iso: 'JO',
    country_code: 400,
    idmc_short_name: 'Jordan',
    idmc_full_name: 'Jordan',
    name: 'Jordan',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [32.33355894864106, 38.30932617187499],
    boundingbox: [29.183401, 34.8844372, 33.3750617, 39.3012981],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Jordania',
    idmc_short_name_fr: 'Â Jordanie',
    idmc_short_name_ar: 'Â Ø§ÙØ£Ø±Ø¯Ù',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'KAZ',
    iso: 'KZ',
    country_code: 398,
    idmc_short_name: 'Kazakhstan',
    idmc_full_name: 'Kazakhstan',
    name: 'Kazakhstan',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Central Asia',
    centroid: [47.2286086, 65.2093197],
    boundingbox: [40.5686476, 46.4932179, 55.4421701, 87.3156316],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'KazajstÃ¡n',
    idmc_short_name_fr: 'Â Kazakhstan',
    idmc_short_name_ar: 'Â ÙØ§Ø²Ø§Ø®Ø³ØªØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'KIR',
    iso: 'KI',
    country_code: 296,
    idmc_short_name: 'Kiribati',
    idmc_full_name: 'Kiribati',
    name: 'Kiribati',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [0.4483283, -171.6645388],
    boundingbox: [-7.0516717, -179.1645388, 7.9483283, -164.1645388],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Kiribati',
    idmc_short_name_fr: 'Â Kiribati',
    idmc_short_name_ar: 'Â ÙÙØ±ÙØ¨Ø§ØªÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'GMB',
    iso: 'GM',
    country_code: 270,
    idmc_short_name: 'Gambia',
    idmc_full_name: 'Gambia',
    name: 'Gambia, The',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [13.368243250897299, -16.094970703125],
    boundingbox: [13.061, -17.0288254, 13.8253137, -13.797778],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Gambia',
    idmc_short_name_fr: 'Â Gambie',
    idmc_short_name_ar: 'Â ØºØ§ÙØ¨ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'GIN',
    iso: 'GN',
    country_code: 324,
    idmc_short_name: 'Guinea',
    idmc_full_name: 'Guinea',
    name: 'Guinea',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [10.7226226, -10.7083587],
    boundingbox: [7.1906045, -15.5680508, 12.67563, -7.6381993],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'West',
    idmc_short_name_es: 'Guinea',
    idmc_short_name_fr: 'Â GuinÃ©e',
    idmc_short_name_ar: 'Â ØºÙÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'GNB',
    iso: 'GW',
    country_code: 624,
    idmc_short_name: 'Guinea-Bissau',
    idmc_full_name: 'Guinea-Bissau',
    name: 'Guinea-Bissau',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [11.43695521614319, -15.09521484375],
    boundingbox: [10.6514215, -16.894523, 12.6862384, -13.6348777],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Guinea-Bissau',
    idmc_short_name_fr: 'Â GuinÃ©e-Bissau',
    idmc_short_name_ar: 'Â ØºÙÙÙØ§ Ø¨ÙØ³Ø§Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'KEN',
    iso: 'KE',
    country_code: 404,
    idmc_short_name: 'Kenya',
    idmc_full_name: 'Kenya',
    name: 'Kenya',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [1.4419683, 38.4313975],
    boundingbox: [
      -5.266007882805485,
      32.958984375,
      5.61598581915534,
      42.5830078125,
    ],
    kampala_signed: 'f',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'Kenia',
    idmc_short_name_fr: 'Â Kenya',
    idmc_short_name_ar: 'Â ÙÙÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'GHA',
    iso: 'GH',
    country_code: 288,
    idmc_short_name: 'Ghana',
    idmc_full_name: 'Ghana',
    name: 'Ghana',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [8.0300284, -1.0800271],
    boundingbox: [4.5392525, -3.260786, 11.1748562, 1.2732942],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'West',
    idmc_short_name_es: 'Ghana',
    idmc_short_name_fr: 'Â Ghana',
    idmc_short_name_ar: 'Â ØºØ§ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'PRK',
    iso: 'KP',
    country_code: 408,
    idmc_short_name: "Dem. People's Rep. Korea",
    idmc_full_name: "Democratic People's Republic of Korea",
    name: 'Korea, Dem. Rep.',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [40.3736611, 127.0870417],
    boundingbox: [37.6279512, 124.0913902, 43.0089642, 130.924647],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Corea del Norte',
    idmc_short_name_fr: 'Â CorÃ©e du Nord',
    idmc_short_name_ar: 'Â ÙÙØ±ÙØ§ Ø§ÙØ´ÙØ§ÙÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'KWT',
    iso: 'KW',
    country_code: 414,
    idmc_short_name: 'Kuwait',
    idmc_full_name: 'Kuwait',
    name: 'Kuwait',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [29.2733964, 47.4979476],
    boundingbox: [28.5243622, 46.5526837, 30.1038082, 49.0046809],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Kuwait',
    idmc_short_name_fr: 'Â KoweÃ¯t',
    idmc_short_name_ar: 'Â Ø§ÙÙÙÙØª',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'KGZ',
    iso: 'KG',
    country_code: 417,
    idmc_short_name: 'Kyrgyzstan',
    idmc_full_name: 'Kyrgyzstan',
    name: 'Kyrgyz Republic',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Central Asia',
    centroid: [41.5089324, 74.724091],
    boundingbox: [39.1728437, 69.2649523, 43.2667971, 80.2295793],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'KirguistÃ¡n',
    idmc_short_name_fr: 'Â Kirghizistan',
    idmc_short_name_ar: 'Â ÙÙØ±ØºÙØ²Ø³ØªØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'LAO',
    iso: 'LA',
    country_code: 418,
    idmc_short_name: 'Lao PDR',
    idmc_full_name: "Lao People's Democratic Republic",
    name: 'Lao PDR',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [20.0171109, 103.378253],
    boundingbox: [13.9096752, 100.0843247, 22.5086717, 107.6349989],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Laos',
    idmc_short_name_fr: 'Â Laos',
    idmc_short_name_ar: 'Â ÙØ§ÙØ³',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'LVA',
    iso: 'LV',
    country_code: 428,
    idmc_short_name: 'Latvia',
    idmc_full_name: 'Latvia',
    name: 'Latvia',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [56.8406494, 24.7537645],
    boundingbox: [55.6746505, 20.6715407, 58.0855688, 28.2414904],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Letonia',
    idmc_short_name_fr: 'Â Lettonie',
    idmc_short_name_ar: 'Â ÙØ§ØªÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'LBN',
    iso: 'LB',
    country_code: 422,
    idmc_short_name: 'Lebanon',
    idmc_full_name: 'Lebanon',
    name: 'Lebanon',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [34.32529192442733, 36.23016357421875],
    boundingbox: [33.0479858, 34.8825667, 34.6923543, 36.625],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'LÃ­bano',
    idmc_short_name_fr: 'Â Liban',
    idmc_short_name_ar: 'Â ÙØ¨ÙØ§Ù',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'LIE',
    iso: 'LI',
    country_code: 438,
    idmc_short_name: 'Liechtenstein',
    idmc_full_name: 'Liechtenstein',
    name: 'Liechtenstein',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [47.1416307, 9.5531527],
    boundingbox: [47.0484291, 9.4716736, 47.270581, 9.6357143],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Liechtenstein',
    idmc_short_name_fr: 'Â Liechtenstein',
    idmc_short_name_ar: 'Â ÙÙØ®ØªÙØ´ØªØ§ÙÙ',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'LTU',
    iso: 'LT',
    country_code: 440,
    idmc_short_name: 'Lithuania',
    idmc_full_name: 'Lithuania',
    name: 'Lithuania',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [55.3500003, 23.7499997],
    boundingbox: [53.8967893, 20.653783, 56.4504213, 26.8355198],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Lituania',
    idmc_short_name_fr: 'Â Lituanie',
    idmc_short_name_ar: 'Â ÙÙØªÙØ§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'LUX',
    iso: 'LU',
    country_code: 442,
    idmc_short_name: 'Luxembourg',
    idmc_full_name: 'Luxembourg',
    name: 'Luxembourg',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [49.8158683, 6.1296751],
    boundingbox: [49.4478539, 5.7357006, 50.1827724, 6.5312481],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Luxemburgo',
    idmc_short_name_fr: 'Â Luxembourg(pays)',
    idmc_short_name_ar: 'Â ÙÙÙØ³ÙØ¨ÙØ±Øº',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'MKD',
    iso: 'MK',
    country_code: 807,
    idmc_short_name: 'Macedonia',
    idmc_full_name: 'The former Yugoslav Republic of Macedonia',
    name: 'Macedonia, FYR',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [41.6171214, 21.7168387],
    boundingbox: [40.8536596, 20.4529023, 42.3735359, 23.034051],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Macedonia',
    idmc_short_name_fr: 'Â RÃ©publique de MacÃ©doine(pays)',
    idmc_short_name_ar: 'Â ÙÙØ¯ÙÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'MYS',
    iso: 'MY',
    country_code: 458,
    idmc_short_name: 'Malaysia',
    idmc_full_name: 'Malaysia',
    name: 'Malaysia',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [2.3923759, 112.8471939],
    boundingbox: [-5.1076241, 105.3471939, 9.8923759, 120.3471939],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Malasia',
    idmc_short_name_fr: 'Â Malaisie',
    idmc_short_name_ar: 'Â ÙØ§ÙÙØ²ÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'MDV',
    iso: 'MV',
    country_code: 462,
    idmc_short_name: 'Maldives',
    idmc_full_name: 'Maldives',
    name: 'Maldives',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [4.7064352, 73.3287853],
    boundingbox: [-0.9074935, 72.3554187, 7.3106246, 73.9700962],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Maldivas',
    idmc_short_name_fr: 'Â Maldives',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø§ÙÙØ§ÙØ¯ÙÙ',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'MLT',
    iso: 'MT',
    country_code: 470,
    idmc_short_name: 'Malta',
    idmc_full_name: 'Malta',
    name: 'Malta',
    geographical_group: 'Middle East and North Africa',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [35.8885993, 14.4476911],
    boundingbox: [35.6029696, 13.9324226, 36.2852706, 14.8267966],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Malta',
    idmc_short_name_fr: 'Â Malte',
    idmc_short_name_ar: 'Â ÙØ§ÙØ·Ø§',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'MHL',
    iso: 'MH',
    country_code: 584,
    idmc_short_name: 'Marshall Islands',
    idmc_full_name: 'Marshall Islands',
    name: 'Marshall Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [6.9518742, 170.9985095],
    boundingbox: [-0.5481258, 163.4985095, 14.4518742, 178.4985095],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Marshall',
    idmc_short_name_fr: 'Â Ãles Marshall(pays)',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙØ§Ø±Ø´Ø§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'FSM',
    iso: 'FM',
    country_code: 583,
    idmc_short_name: 'Micronesia',
    idmc_full_name: 'Micronesia (Federated States of)',
    name: 'Micronesia, Fed. Sts.',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [5.5600565, 150.1982846],
    boundingbox: [0.827, 137.2234512, 10.291, 163.2364054],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Micronesia',
    idmc_short_name_fr: 'Â Ãtats fÃ©dÃ©rÃ©s de MicronÃ©sie(pays)',
    idmc_short_name_ar: 'Â ÙÙØ§ÙØ§Øª ÙÙÙØ±ÙÙÙØ³ÙØ§ Ø§ÙÙØªØ­Ø¯Ø©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'MDA',
    iso: 'MD',
    country_code: 498,
    idmc_short_name: 'Moldova',
    idmc_full_name: 'Republic of Moldova',
    name: 'Moldova',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [47.286747, 28.5110236],
    boundingbox: [45.4674193, 26.6162823, 48.4918695, 30.1635137],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Moldova',
    idmc_short_name_fr: 'Â Moldavie',
    idmc_short_name_ar: 'Â ÙÙÙØ¯ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'MCO',
    iso: 'MC',
    country_code: 492,
    idmc_short_name: 'Monaco',
    idmc_full_name: 'Monaco',
    name: 'Monaco',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [43.7311424, 7.4197576],
    boundingbox: [43.7247599, 7.4090279, 43.7519311, 7.4398704],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'MÃ³naco',
    idmc_short_name_fr: 'Â Monaco',
    idmc_short_name_ar: 'Â ÙÙÙØ§ÙÙ',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'MAC',
    iso: 'MO',
    country_code: 446,
    idmc_short_name: 'Macao, China',
    idmc_full_name: 'China, Macao Special Administrative Region',
    name: 'Macao SAR, China',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [-2.88027, 23.6597996],
    boundingbox: [22.1952625, 113.5523805, 22.1961258, 113.5535285],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Macao',
    idmc_short_name_fr: 'Â Macao',
    idmc_short_name_ar: 'Â ÙØ§ÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'MNG',
    iso: 'MN',
    country_code: 496,
    idmc_short_name: 'Mongolia',
    idmc_full_name: 'Mongolia',
    name: 'Mongolia',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [46.8250388, 103.8499736],
    boundingbox: [41.5804176, 87.73762, 52.1496, 119.931949],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Mongolia',
    idmc_short_name_fr: 'Â Mongolie',
    idmc_short_name_ar: 'Â ÙÙØºÙÙÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'MNE',
    iso: 'ME',
    country_code: 499,
    idmc_short_name: 'Montenegro',
    idmc_full_name: 'Montenegro',
    name: 'Montenegro',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [42.7728491, 19.2408586],
    boundingbox: [41.7495999, 18.4195781, 43.5585061, 20.3561641],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Montenegro',
    idmc_short_name_fr: 'Â MontÃ©nÃ©gro',
    idmc_short_name_ar: 'Â Ø§ÙØ¬Ø¨Ù Ø§ÙØ£Ø³ÙØ¯',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'MMR',
    iso: 'MM',
    country_code: 104,
    idmc_short_name: 'Myanmar',
    idmc_full_name: 'Myanmar',
    name: 'Myanmar',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [22.004174972902003, 96.328125],
    boundingbox: [9.5375, 92.1719423, 28.547835, 101.1700796],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Myanmar',
    idmc_short_name_fr: 'Â Myanmar',
    idmc_short_name_ar: 'Â ÙÙØ§ÙÙØ§Ø±',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'NPL',
    iso: 'NP',
    country_code: 524,
    idmc_short_name: 'Nepal',
    idmc_full_name: 'Nepal',
    name: 'Nepal',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [28.1083929, 84.0917139],
    boundingbox: [26.3477581, 80.0586226, 30.446945, 88.2015257],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Nepal',
    idmc_short_name_fr: 'Â NÃ©pal',
    idmc_short_name_ar: 'Â ÙÙØ¨Ø§Ù',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'NLD',
    iso: 'NL',
    country_code: 528,
    idmc_short_name: 'Netherlands',
    idmc_full_name: 'Netherlands',
    name: 'Netherlands',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [52.2379891, 5.53460738161551],
    boundingbox: [
      50.43651601698633,
      2.713623046875,
      53.81362579235235,
      7.80029296875,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'PaÃ­ses Bajos',
    idmc_short_name_fr: 'Â Pays-Bas',
    idmc_short_name_ar: 'Â ÙÙÙÙØ¯Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'MWI',
    iso: 'MW',
    country_code: 454,
    idmc_short_name: 'Malawi',
    idmc_full_name: 'Malawi',
    name: 'Malawi',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-13.2687204, 33.9301963],
    boundingbox: [-17.1295217, 32.6703616, -9.3683261, 35.9185731],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'South',
    idmc_short_name_es: 'Malawi',
    idmc_short_name_fr: 'Â Malawi',
    idmc_short_name_ar: 'Â ÙØ§ÙØ§ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'LBR',
    iso: 'LR',
    country_code: 430,
    idmc_short_name: 'Liberia',
    idmc_full_name: 'Liberia',
    name: 'Liberia',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [5.7499721, -9.3658524],
    boundingbox: [4.1555907, -11.6080764, 8.5519861, -7.367323],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'West',
    idmc_short_name_es: 'Liberia',
    idmc_short_name_fr: 'Â Liberia',
    idmc_short_name_ar: 'Â ÙÙØ¨ÙØ±ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'MLI',
    iso: 'ML',
    country_code: 466,
    idmc_short_name: 'Mali',
    idmc_full_name: 'Mali',
    name: 'Mali',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [16.3700359, -2.2900239],
    boundingbox: [10.147811, -12.2402835, 25.001084, 4.2673828],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Mali',
    idmc_short_name_fr: 'Â Mali',
    idmc_short_name_ar: 'Â ÙØ§ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'MDG',
    iso: 'MG',
    country_code: 450,
    idmc_short_name: 'Madagascar',
    idmc_full_name: 'Madagascar',
    name: 'Madagascar',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-18.9249604, 46.4416422],
    boundingbox: [-25.784021, 42.9680076, -11.732889, 50.6727307],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'Madagascar',
    idmc_short_name_fr: 'Â Madagascar',
    idmc_short_name_ar: 'Â ÙØ¯ØºØ´ÙØ±',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'MOZ',
    iso: 'MZ',
    country_code: 508,
    idmc_short_name: 'Mozambique',
    idmc_full_name: 'Mozambique',
    name: 'Mozambique',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-19.302233, 34.9144977],
    boundingbox: [-26.9209427, 30.2131759, -10.3252149, 41.0545908],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'South',
    idmc_short_name_es: 'Mozambique',
    idmc_short_name_fr: 'Â Mozambique',
    idmc_short_name_ar: 'Â ÙÙØ²ÙØ¨ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'LSO',
    iso: 'LS',
    country_code: 426,
    idmc_short_name: 'Lesotho',
    idmc_full_name: 'Lesotho',
    name: 'Lesotho',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Southern Africa',
    centroid: [-29.6039267, 28.3350193],
    boundingbox: [-30.675575, 27.0114632, -28.570615, 29.4557099],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'South',
    idmc_short_name_es: 'Lesotho',
    idmc_short_name_fr: 'Â Lesotho',
    idmc_short_name_ar: 'Â ÙÙØ³ÙØªÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'NAM',
    iso: 'NA',
    country_code: 516,
    idmc_short_name: 'Namibia',
    idmc_full_name: 'Namibia',
    name: 'Namibia',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Southern Africa',
    centroid: [-23.2335499, 17.3231107],
    boundingbox: [-28.96945, 11.5280384, -16.9634855, 25.2616564],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'South',
    idmc_short_name_es: 'Namibia',
    idmc_short_name_fr: 'Â Namibie',
    idmc_short_name_ar: 'Â ÙØ§ÙÙØ¨ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'MAR',
    iso: 'MA',
    country_code: 504,
    idmc_short_name: 'Morocco',
    idmc_full_name: 'Morocco',
    name: 'Morocco',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: 'Northern Africa',
    centroid: [31.1728192, -7.3366043],
    boundingbox: [21.3365321, -17.2551456, 36.0505269, -0.998429],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'North',
    idmc_short_name_es: 'Marruecos',
    idmc_short_name_fr: 'Â Maroc',
    idmc_short_name_ar: 'Â Ø§ÙÙØºØ±Ø¨',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'MRT',
    iso: 'MR',
    country_code: 478,
    idmc_short_name: 'Mauritania',
    idmc_full_name: 'Mauritania',
    name: 'Mauritania',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [20.2540382, -9.2399263],
    boundingbox: [14.7209909, -17.068081, 27.314942, -4.8333344],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'North',
    idmc_short_name_es: 'Mauritania',
    idmc_short_name_fr: 'Â Mauritanie',
    idmc_short_name_ar: 'Â ÙÙØ±ÙØªØ§ÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'MUS',
    iso: 'MU',
    country_code: 480,
    idmc_short_name: 'Mauritius',
    idmc_full_name: 'Mauritius',
    name: 'Mauritius',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-20.2759451, 57.5703566],
    boundingbox: [-20.725, 56.3825151, -10.138, 63.7151319],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'East',
    idmc_short_name_es: 'Mauricio',
    idmc_short_name_fr: 'Â Maurice(pays)',
    idmc_short_name_ar: 'Â ÙÙØ±ÙØ´ÙÙØ³',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'NCL',
    iso: 'NC',
    country_code: 540,
    idmc_short_name: 'New Caledonia',
    idmc_full_name: 'New Caledonia',
    name: 'New Caledonia',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Melanesia',
    centroid: [-21.3019905, 165.4880773],
    boundingbox: [-23.2217509, 157.9847541, -17.6868616, 172.3057152],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Nueva Caledonia',
    idmc_short_name_fr: 'Â Nouvelle-CalÃ©donie',
    idmc_short_name_ar: 'Â ÙØ§ÙÙØ¯ÙÙÙØ§ Ø§ÙØ¬Ø¯ÙØ¯Ø©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'NZL',
    iso: 'NZ',
    country_code: 554,
    idmc_short_name: 'New Zealand',
    idmc_full_name: 'New Zealand',
    name: 'New Zealand',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Australia and New Zealand',
    centroid: [-41.5000831, 172.8344077],
    boundingbox: [
      -49.49667452747043,
      163.212890625,
      -31.615965936476076,
      182.109375,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Nueva Zelanda',
    idmc_short_name_fr: 'Â Nouvelle-ZÃ©lande',
    idmc_short_name_ar: 'Â ÙÙÙØ²ÙÙÙØ¯Ø§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'MNP',
    iso: 'MP',
    country_code: 580,
    idmc_short_name: 'Northern Mariana Islands',
    idmc_full_name: 'Northern Mariana Islands',
    name: 'Northern Mariana Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [14.1490205, 145.213452483189],
    boundingbox: [14.036565, 144.813338, 20.616556, 146.154418],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Marianas del Norte',
    idmc_short_name_fr: 'Â Ãles Mariannes du Nord',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙØ§Ø±ÙØ§ÙØ§ Ø§ÙØ´ÙØ§ÙÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'NOR',
    iso: 'NO',
    country_code: 578,
    idmc_short_name: 'Norway',
    idmc_full_name: 'Norway',
    name: 'Norway',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [64.5731537, 11.5280364395482],
    boundingbox: [57.7590052, 4.0875274, 71.3848787, 31.7614911],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Noruega',
    idmc_short_name_fr: 'Â NorvÃ¨ge',
    idmc_short_name_ar: 'Â Ø§ÙÙØ±ÙÙØ¬',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'OMN',
    iso: 'OM',
    country_code: 512,
    idmc_short_name: 'Oman',
    idmc_full_name: 'Oman',
    name: 'Oman',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [21.0000287, 57.0036901],
    boundingbox: [16.4649608, 52, 26.7026737, 60.054577],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'OmÃ¡n',
    idmc_short_name_fr: 'Â Oman',
    idmc_short_name_ar: 'Â Ø¹ÙØ§Ù',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'PAK',
    iso: 'PK',
    country_code: 586,
    idmc_short_name: 'Pakistan',
    idmc_full_name: 'Pakistan',
    name: 'Pakistan',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [30.3308401, 71.247499],
    boundingbox: [23.5393916, 60.872855, 37.084107, 77.1203914],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'PakistÃ¡n',
    idmc_short_name_fr: 'Â Pakistan',
    idmc_short_name_ar: 'Â Ø¨Ø§ÙØ³ØªØ§Ù',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'PLW',
    iso: 'PW',
    country_code: 585,
    idmc_short_name: 'Palau',
    idmc_full_name: 'Palau',
    name: 'Palau',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [6.097367, 133.313631],
    boundingbox: [2.748, 131.0685462, 8.222, 134.7714735],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Palaos',
    idmc_short_name_fr: 'Â Palaos',
    idmc_short_name_ar: 'Â Ø¨Ø§ÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'PSE',
    iso: 'PS',
    country_code: 275,
    idmc_short_name: 'Palestine',
    idmc_full_name: 'State of Palestine',
    name: 'West Bank and Gaza',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [32.27784451498272, 35.29632568359375],
    boundingbox: [31.2201289, 34.0689732, 32.5521479, 35.5734946],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Palestina',
    idmc_short_name_fr: 'Â Palestine',
    idmc_short_name_ar: 'Â ÙÙØ³Ø·ÙÙ',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'PNG',
    iso: 'PG',
    country_code: 598,
    idmc_short_name: 'Papua New Guinea',
    idmc_full_name: 'Papua New Guinea',
    name: 'Papua New Guinea',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Melanesia',
    centroid: [-5.6816069, 144.2489081],
    boundingbox: [-13.1816069, 136.7489081, 1.8183931, 151.7489081],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'PapÃºa Nueva Guinea',
    idmc_short_name_fr: 'Â Papouasie-Nouvelle-GuinÃ©e',
    idmc_short_name_ar: 'Â Ø¨Ø§Ø¨ÙØ§ ØºÙÙÙØ§ Ø§ÙØ¬Ø¯ÙØ¯Ø©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'PHL',
    iso: 'PH',
    country_code: 608,
    idmc_short_name: 'Philippines',
    idmc_full_name: 'Philippines',
    name: 'Philippines',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [12.7503486, 122.7312101],
    boundingbox: [4.2158064, 114.0952145, 21.3217806, 126.8072562],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Filipinas',
    idmc_short_name_fr: 'Â Philippines',
    idmc_short_name_ar: 'Â Ø§ÙÙÙØ¨ÙÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'POL',
    iso: 'PL',
    country_code: 616,
    idmc_short_name: 'Poland',
    idmc_full_name: 'Poland',
    name: 'Poland',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [52.0977181, 19.0258159],
    boundingbox: [49.0020468, 14.1229707, 55.0336963, 24.145783],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Polonia',
    idmc_short_name_fr: 'Â Pologne',
    idmc_short_name_ar: 'Â Ø¨ÙÙÙØ¯Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'PRT',
    iso: 'PT',
    country_code: 620,
    idmc_short_name: 'Portugal',
    idmc_full_name: 'Portugal',
    name: 'Portugal',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [40.033265, -7.8896263],
    boundingbox: [
      36.146746777814364,
      -11.085205078125,
      42.69858589169842,
      -5.614013671875,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Portugal',
    idmc_short_name_fr: 'Â Portugal',
    idmc_short_name_ar: 'Â Ø§ÙØ¨Ø±ØªØºØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'QAT',
    iso: 'QA',
    country_code: 634,
    idmc_short_name: 'Qatar',
    idmc_full_name: 'Qatar',
    name: 'Qatar',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [25.3336984, 51.2295295],
    boundingbox: [
      24.191858272317656,
      50.3228759765625,
      26.377106813670053,
      52.0147705078125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Qatar',
    idmc_short_name_fr: 'Â Qatar',
    idmc_short_name_ar: 'Â ÙØ·Ø±',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'ROU',
    iso: 'RO',
    country_code: 642,
    idmc_short_name: 'Romania',
    idmc_full_name: 'Romania',
    name: 'Romania',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [45.9852129, 24.6859225],
    boundingbox: [43.618682, 20.2619773, 48.2653964, 30.0454257],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'RumanÃ­a',
    idmc_short_name_fr: 'Â Roumanie',
    idmc_short_name_ar: 'Â Ø±ÙÙØ§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'RUS',
    iso: 'RU',
    country_code: 643,
    idmc_short_name: 'Russia',
    idmc_full_name: 'Russian Federation',
    name: 'Russian Federation',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [64.6863136, 97.7453061],
    boundingbox: [
      39.50404070558415,
      20.390625,
      79.23718500609336,
      192.48046875,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Rusia',
    idmc_short_name_fr: 'Â Russie',
    idmc_short_name_ar: 'Â Ø±ÙØ³ÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'WSM',
    iso: 'WS',
    country_code: 882,
    idmc_short_name: 'Samoa',
    idmc_full_name: 'Samoa',
    name: 'Samoa',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Polynesia',
    centroid: [-13.7693895, -172.1200508],
    boundingbox: [-14.2770916, -173.0091864, -13.2381892, -171.1929229],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Samoa',
    idmc_short_name_fr: 'Â Samoa',
    idmc_short_name_ar: 'Â Ø³Ø§ÙÙØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'SMR',
    iso: 'SM',
    country_code: 674,
    idmc_short_name: 'San Marino',
    idmc_full_name: 'San Marino',
    name: 'San Marino',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [43.9458623, 12.458306],
    boundingbox: [43.8937002, 12.4033246, 43.992093, 12.5160665],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San Marino',
    idmc_short_name_fr: 'Â Saint-Marin',
    idmc_short_name_ar: 'Â Ø³Ø§Ù ÙØ§Ø±ÙÙÙ',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'SAU',
    iso: 'SA',
    country_code: 682,
    idmc_short_name: 'Saudi Arabia',
    idmc_full_name: 'Saudi Arabia',
    name: 'Saudi Arabia',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [25.6242618, 42.3528328],
    boundingbox: [16.29, 34.4970153, 32.1543377, 55.6666985],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Arabia Saudita',
    idmc_short_name_fr: 'Â Arabie saoudite',
    idmc_short_name_ar: 'Â Ø§ÙØ³Ø¹ÙØ¯ÙØ©',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'KOR',
    iso: 'KR',
    country_code: 410,
    idmc_short_name: 'Korea',
    idmc_full_name: 'Republic of Korea',
    name: 'Korea, Rep.',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [36.3571, 127.807],
    boundingbox: [
      32.63012300670739,
      125.01342773437499,
      39.12153746241925,
      130.2099609375,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Corea del Sur',
    idmc_short_name_fr: 'Â CorÃ©e du Sud',
    idmc_short_name_ar: 'Â ÙÙØ±ÙØ§ Ø§ÙØ¬ÙÙØ¨ÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'IRN',
    iso: 'IR',
    country_code: 364,
    idmc_short_name: 'Iran',
    idmc_full_name: 'Iran (Islamic Republic of)',
    name: 'Iran, Islamic Rep.',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [32.5629997, 54.3032],
    boundingbox: [
      23.443088931121785,
      42.9345703125,
      41.1455697310095,
      64.3359375,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'IrÃ¡n',
    idmc_short_name_fr: 'Â Iran',
    idmc_short_name_ar: 'Â Ø¥ÙØ±Ø§Ù',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'NRU',
    iso: 'NR',
    country_code: 520,
    idmc_short_name: 'Nauru',
    idmc_full_name: 'Republic of Nauru',
    name: 'Nauru',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Micronesia',
    centroid: [-0.522778, 166.931503],
    boundingbox: [-0.554293, 166.90957, -0.500736, 166.960553],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Nauru',
    idmc_short_name_fr: 'Â Nauru',
    idmc_short_name_ar: 'Â ÙØ§ÙØ±Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'SRK',
    iso: '',
    country_code: 680,
    idmc_short_name: 'Sark',
    idmc_full_name: 'Sark',
    name: 'Sark',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: 'Channel Islands',
    centroid: [49.4283373, -2.35993944568253],
    boundingbox: [49.4000521, 49.4522855, -2.3952712, -2.3378459],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Sark',
    idmc_short_name_fr: 'Sark',
    idmc_short_name_ar: 'Ø³Ø§Ø±Ù',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'ATF',
    iso: '',
    country_code: 260,
    idmc_short_name: 'French Southern Territories',
    idmc_full_name: 'French Southern Territories',
    name: 'French Southern Territories',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-44.1511785, 63.8604556],
    boundingbox: [-50.2187169, -11.3139928, 39.4138676, 77.8494974],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Territorios Australes Franceses',
    idmc_short_name_fr: 'Â Terres australes et antarctiques franÃ§aises',
    idmc_short_name_ar: 'Â Ø£Ø±Ø§Ø¶ ÙØ±ÙØ³ÙØ© Ø¬ÙÙØ¨ÙØ© ÙØ£ÙØªØ§Ø±ØªÙÙÙØ©',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'IOT',
    iso: '',
    country_code: 86,
    idmc_short_name: 'British Indian Ocean Territory',
    idmc_full_name: 'British Indian Ocean Territory',
    name: 'British Indian Ocean Territory',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-6.4157192, 72.1173961],
    boundingbox: [-7.6454079, -5.037066, 71.036504, 72.7020157],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Territorio BritÃ¡nico del OcÃ©ano Ãndico',
    idmc_short_name_fr: "Â Territoire britannique de l'ocÃ©an Indien",
    idmc_short_name_ar: 'Â Ø¥ÙÙÙÙ Ø§ÙÙØ­ÙØ· Ø§ÙÙÙØ¯Ù Ø§ÙØ¨Ø±ÙØ·Ø§ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'ALA',
    iso: '',
    country_code: 248,
    idmc_short_name: 'Ãland Islands',
    idmc_full_name: 'Ãland Islands',
    name: 'Ãland Islands',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: '',
    centroid: [60.2166218, 19.9438638],
    boundingbox: [59.4541578, 60.87665, 19.0832098, 21.3456556],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Ãland',
    idmc_short_name_fr: 'Â Ãles Ãland',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø£ÙÙØ§ÙØ¯',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'JEY',
    iso: '',
    country_code: 832,
    idmc_short_name: 'Jersey',
    idmc_full_name: 'Jersey',
    name: 'Jersey',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: 'Channel Islands',
    centroid: [49.21230655, -2.12559995964288],
    boundingbox: [49.1625179, 49.2621288, -2.254512, -2.0104193],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Jersey',
    idmc_short_name_fr: 'Â Jersey',
    idmc_short_name_ar: 'Â Ø¬ÙØ±Ø²Ù',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'GGY',
    iso: '',
    country_code: 831,
    idmc_short_name: 'Guernsey',
    idmc_full_name: 'Guernsey',
    name: 'Guernsey',
    geographical_group: 'Europe & Central Asia',
    region: 'Europe',
    sub_region: 'Channel Islands',
    centroid: [49.46229125, -2.58120225032944],
    boundingbox: [49.4155331, 49.5090776, -2.6751703, -2.501814],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Guernsey',
    idmc_short_name_fr: 'Â Guernesey',
    idmc_short_name_ar: 'Â ØºÙØ±ÙØ²Ù',
    geographical_group_grid: 'Europe & Central Asia',
  },
  {
    iso3: 'GUF',
    iso: '',
    country_code: 254,
    idmc_short_name: 'French Guiana',
    idmc_full_name: 'French Guiana',
    name: 'French Guiana',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [4.0039882, -52.999998],
    boundingbox: [2.112222, 5.7507111, -54.60278, -51.6346139],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Guayana Francesa',
    idmc_short_name_fr: 'Â Guyane',
    idmc_short_name_ar: 'Â ØºÙÙØ§ÙØ§ Ø§ÙÙØ±ÙØ³ÙØ©',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'MTQ',
    iso: '',
    country_code: 474,
    idmc_short_name: 'Martinique',
    idmc_full_name: 'Martinique',
    name: 'Martinique',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [14.6368275, -61.0157355341703],
    boundingbox: [14.3948596, 14.8787029, -61.2290815, -60.8095833],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Martinica',
    idmc_short_name_fr: 'Â Martinique',
    idmc_short_name_ar: 'Â ÙØ§Ø±ØªÙÙÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'GLP',
    iso: '',
    country_code: 312,
    idmc_short_name: 'Guadeloupe',
    idmc_full_name: 'Guadeloupe',
    name: 'Guadeloupe',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [16.2490067, -61.5650444],
    boundingbox: [15.8320085, 16.5144664, -61.809764, -61.0003663],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Guadalupe',
    idmc_short_name_fr: 'Â Guadeloupe',
    idmc_short_name_ar: 'Â ØºÙØ§Ø¯ÙÙØ¨',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'SPM',
    iso: '',
    country_code: 666,
    idmc_short_name: 'Saint Pierre and Miquelon',
    idmc_full_name: 'Saint Pierre and Miquelon',
    name: 'Saint Pierre and Miquelon',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: '',
    centroid: [46.8374544, -56.2120555],
    boundingbox: [46.5507173, 47.365, -56.6972961, -55.9033333],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San Pedro y MiquelÃ³n',
    idmc_short_name_fr: 'Â Saint-Pierre-et-Miquelon',
    idmc_short_name_ar: 'Â Ø³Ø§Ù Ø¨ÙÙØ± ÙÙÙÙÙÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'SGS',
    iso: '',
    country_code: 239,
    idmc_short_name: 'South Georgia and the South Sandwich Islands',
    idmc_full_name: 'South Georgia and the South Sandwich Islands',
    name: 'South Georgia and the South Sandwich Islands',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-54.8432857, -35.8090698],
    boundingbox: [-59.684, -53.3500755, -42.354739, -25.8468303],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Georgia del Sur e Islas Sandwich del Sur',
    idmc_short_name_fr: 'Â GÃ©orgie du Sud-et-les Ã®les Sandwich du Sud',
    idmc_short_name_ar:
      'Â Ø¬ÙØ±Ø¬ÙØ§ Ø§ÙØ¬ÙÙØ¨ÙØ© ÙØ¬Ø²Ø± Ø³Ø§ÙØ¯ÙÙØªØ´ Ø§ÙØ¬ÙÙØ¨ÙØ©',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BES',
    iso: '',
    country_code: 535,
    idmc_short_name: 'Bonaire, Sint Eustatius and Saba',
    idmc_full_name: 'Bonaire, Sint Eustatius and Saba',
    name: 'Bonaire, Sint Eustatius and Saba',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [12.167, -68.2909680033101],
    boundingbox: [11.825, 12.512, -68.6255319, -67.9907966],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bonaire',
    idmc_short_name_fr: 'Â Pays-Bas caribÃ©ens',
    idmc_short_name_ar: 'Â Ø§ÙØ¬Ø²Ø± Ø§ÙÙØ§Ø±ÙØ¨ÙØ© Ø§ÙÙÙÙÙØ¯ÙØ©',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'MSR',
    iso: '',
    country_code: 500,
    idmc_short_name: 'Montserrat',
    idmc_full_name: 'Montserrat',
    name: 'Montserrat',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [16.7417041, -62.1916844],
    boundingbox: [16.475, 17.0152978, -62.450667, -61.9353818],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Montserrat',
    idmc_short_name_fr: 'Â Montserrat',
    idmc_short_name_ar: 'Â ÙÙÙØªØ³Ø±Ø§Øª',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BLM',
    iso: '',
    country_code: 652,
    idmc_short_name: 'Saint BarthÃ©lemy',
    idmc_full_name: 'Saint BarthÃ©lemy',
    name: 'Saint BarthÃ©lemy',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [17.9007731, -62.7971617856874],
    boundingbox: [17.670931, 18.1375569, -63.06639, -62.5844019],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San BartolomÃ©',
    idmc_short_name_fr: 'Â Saint-BarthÃ©lemy',
    idmc_short_name_ar: 'Â Ø³Ø§Ù Ø¨Ø§Ø±ØªÙÙÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'FLK',
    iso: '',
    country_code: 238,
    idmc_short_name: 'Falkland Islands (Malvinas)',
    idmc_full_name: 'Falkland Islands (Malvinas)',
    name: 'Falkland Islands (Malvinas)',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-51.9666424, -59.5500387],
    boundingbox: [-53.1186766, -50.7973007, -61.7726772, -57.3662367],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Falkland Islands (Malvinas)',
    idmc_short_name_fr: 'Â Malouines',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙÙÙÙØ§ÙØ¯',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BVT',
    iso: '',
    country_code: 74,
    idmc_short_name: 'Bouvet Island',
    idmc_full_name: 'Bouvet Island',
    name: 'Bouvet Island',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-54.4215, 3.35744155625],
    boundingbox: [-54.654, -54.187, 2.9345531, 3.7791099],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Isla Bouvet',
    idmc_short_name_fr: 'Â Ãle Bouvet',
    idmc_short_name_ar: 'Â Ø¬Ø²ÙØ±Ø© Ø¨ÙÙÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'ABW',
    iso: 'AW',
    country_code: 533,
    idmc_short_name: 'Aruba',
    idmc_full_name: 'Aruba',
    name: 'Aruba',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [12.51434, -69.98565],
    boundingbox: [12.262778, -70.2695876, 12.823, -69.661226],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Aruba',
    idmc_short_name_fr: 'Â Aruba',
    idmc_short_name_ar: 'Â Ø£Ø±ÙØ¨Ø§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'ATG',
    iso: 'AG',
    country_code: 28,
    idmc_short_name: 'Antigua and Barbuda',
    idmc_full_name: 'Antigua and Barbuda',
    name: 'Antigua and Barbuda',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [17.079128, -61.8222516],
    boundingbox: [16.7573901, -62.5536517, 17.929, -61.447857],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Antigua y Barbuda',
    idmc_short_name_fr: 'Â Antigua-et-Barbuda',
    idmc_short_name_ar: 'Â Ø£ÙØªÙØºÙØ§ ÙØ¨Ø§Ø±Ø¨ÙØ¯Ø§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'ARG',
    iso: 'AR',
    country_code: 32,
    idmc_short_name: 'Argentina',
    idmc_full_name: 'Argentina',
    name: 'Argentina',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-34.9964963, -64.9672817],
    boundingbox: [-55.1850761, -73.5600329, -21.781168, -53.6374515],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Argentina',
    idmc_short_name_fr: 'Â Argentine',
    idmc_short_name_ar: 'Â Ø§ÙØ£Ø±Ø¬ÙØªÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BHS',
    iso: 'BS',
    country_code: 44,
    idmc_short_name: 'Bahamas',
    idmc_full_name: 'Bahamas',
    name: 'Bahamas, The',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [24.7736546, -78.0000547],
    boundingbox: [
      20.29311344754411,
      -79.991455078125,
      27.771051193172273,
      -72.00439453125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bahamas',
    idmc_short_name_fr: 'Â Bahamas',
    idmc_short_name_ar: 'Â Ø¨Ø§ÙØ§ÙØ§Ø³',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BRB',
    iso: 'BB',
    country_code: 52,
    idmc_short_name: 'Barbados',
    idmc_full_name: 'Barbados',
    name: 'Barbados',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [13.1500331, -59.5250305],
    boundingbox: [12.845, -59.8562115, 13.535, -59.2147175],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Barbados',
    idmc_short_name_fr: 'Â Barbade',
    idmc_short_name_ar: 'Â Ø¨Ø§Ø±Ø¨Ø§Ø¯ÙØ³',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BLZ',
    iso: 'BZ',
    country_code: 84,
    idmc_short_name: 'Belize',
    idmc_full_name: 'Belize',
    name: 'Belize',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [16.8259793, -88.7600927],
    boundingbox: [15.8857286, -89.2262083, 18.496001, -87.3098494],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Belice',
    idmc_short_name_fr: 'Â Belize',
    idmc_short_name_ar: 'Â Ø¨ÙÙØ²',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BRA',
    iso: 'BR',
    country_code: 76,
    idmc_short_name: 'Brazil',
    idmc_full_name: 'Brazil',
    name: 'Brazil',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-10.3333333, -53.2],
    boundingbox: [-33.8689056, -73.9830625, 5.2842873, -28.6341164],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Brasil',
    idmc_short_name_fr: 'Â BrÃ©sil',
    idmc_short_name_ar: 'Â Ø§ÙØ¨Ø±Ø§Ø²ÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'CYM',
    iso: 'KY',
    country_code: 136,
    idmc_short_name: 'Cayman Islands',
    idmc_full_name: 'Cayman Islands',
    name: 'Cayman Islands',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [19.5417212, -80.5667132],
    boundingbox: [19.0620619, -81.6313748, 19.9573759, -79.5110954],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas CaimÃ¡n',
    idmc_short_name_fr: 'Â Ãles CaÃ¯mans',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ÙØ§ÙÙØ§Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'COL',
    iso: 'CO',
    country_code: 170,
    idmc_short_name: 'Colombia',
    idmc_full_name: 'Colombia',
    name: 'Colombia',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [2.8894434, -73.783892],
    boundingbox: [-4.2316872, -82.1243666, 16.0571269, -66.8511907],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Colombia',
    idmc_short_name_fr: 'Â Colombie',
    idmc_short_name_ar: 'Â ÙÙÙÙÙØ¨ÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'CRI',
    iso: 'CR',
    country_code: 188,
    idmc_short_name: 'Costa Rica',
    idmc_full_name: 'Costa Rica',
    name: 'Costa Rica',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [10.2735633, -84.0739102],
    boundingbox: [
      7.645664723491027,
      -86.517333984375,
      11.576906799408956,
      -81.73828125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Costa Rica',
    idmc_short_name_fr: 'Â Costa Rica',
    idmc_short_name_ar: 'Â ÙÙØ³ØªØ§Ø±ÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'CUB',
    iso: 'CU',
    country_code: 192,
    idmc_short_name: 'Cuba',
    idmc_full_name: 'Cuba',
    name: 'Cuba',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [23.0131338, -80.8328748],
    boundingbox: [19.6275294, -85.1679702, 23.4816972, -73.9190004],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Cuba',
    idmc_short_name_fr: 'Â Cuba',
    idmc_short_name_ar: 'Â ÙÙØ¨Ø§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'CUW',
    iso: '',
    country_code: 531,
    idmc_short_name: 'CuraÃ§ao',
    idmc_full_name: 'CuraÃ§ao',
    name: 'CuraÃ§ao',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [12.21340415, -69.0408367569724],
    boundingbox: [12.0342303, -69.1627087, 12.3928011, -68.7366375],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Curazao',
    idmc_short_name_fr: 'Â CuraÃ§ao',
    idmc_short_name_ar: 'Â ÙÙØ±Ø§Ø³Ø§Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'DMA',
    iso: 'DM',
    country_code: 212,
    idmc_short_name: 'Dominica',
    idmc_full_name: 'Dominica',
    name: 'Dominica',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [15.4113138, -61.3653618],
    boundingbox: [15.0074207, -61.6869184, 15.7872222, -61.0329895],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'DomÃ­nica',
    idmc_short_name_fr: 'Â Dominique',
    idmc_short_name_ar: 'Â Ø¯ÙÙÙÙÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'BOL',
    iso: 'BO',
    country_code: 68,
    idmc_short_name: 'Bolivia',
    idmc_full_name: 'Bolivia (Plurinational State of)',
    name: 'Bolivia',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-16.7091, -64.6652],
    boundingbox: [
      -23.90592692731471,
      -70.86181640625,
      -8.68963906812765,
      -56.2939453125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Bolivia',
    idmc_short_name_fr: 'Â Bolivie',
    idmc_short_name_ar: 'Â Ø¨ÙÙÙÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'DOM',
    iso: 'DO',
    country_code: 214,
    idmc_short_name: 'Dominican Republic',
    idmc_full_name: 'Dominican Republic',
    name: 'Dominican Republic',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [19.145168196205297, -69.8291015625],
    boundingbox: [
      17.29819876772391,
      -72.2845458984375,
      20.33432561683554,
      -68.0987548828125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'RepÃºblica Dominicana',
    idmc_short_name_fr: 'Â RÃ©publique dominicaine',
    idmc_short_name_ar: 'Â Ø¬ÙÙÙØ±ÙØ© Ø§ÙØ¯ÙÙÙÙÙÙØ§Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'ECU',
    iso: 'EC',
    country_code: 218,
    idmc_short_name: 'Ecuador',
    idmc_full_name: 'Ecuador',
    name: 'Ecuador',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-1.3397668, -79.3666965],
    boundingbox: [
      -5.615985819155327,
      -81.39770507812499,
      1.7355743631421197,
      -74.5751953125,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Ecuador',
    idmc_short_name_fr: 'Â Ãquateur(pays)',
    idmc_short_name_ar: 'Â Ø§ÙØ¥ÙÙØ§Ø¯ÙØ±',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'SLV',
    iso: 'SV',
    country_code: 222,
    idmc_short_name: 'El Salvador',
    idmc_full_name: 'El Salvador',
    name: 'El Salvador',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [13.8000382, -88.9140683],
    boundingbox: [12.976046, -90.1790975, 14.4510488, -87.6351394],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'El Salvador',
    idmc_short_name_fr: 'Â Salvador',
    idmc_short_name_ar: 'Â Ø§ÙØ³ÙÙØ§Ø¯ÙØ±',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'GRD',
    iso: 'GD',
    country_code: 308,
    idmc_short_name: 'Grenada',
    idmc_full_name: 'Grenada',
    name: 'Grenada',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [12.1360374, -61.6904045],
    boundingbox: [11.786, -62.0065868, 12.5966532, -61.1732143],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Granada',
    idmc_short_name_fr: 'Â Grenade(pays)',
    idmc_short_name_ar: 'Â ØºØ±ÙÙØ§Ø¯Ø§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'GTM',
    iso: 'GT',
    country_code: 320,
    idmc_short_name: 'Guatemala',
    idmc_full_name: 'Guatemala',
    name: 'Guatemala',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [15.30008112737089, -91.1700439453125],
    boundingbox: [13.6345804, -92.3105242, 17.8165947, -88.1755849],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Guatemala',
    idmc_short_name_fr: 'Â Guatemala',
    idmc_short_name_ar: 'Â ØºÙØ§ØªÙÙØ§ÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'GUY',
    iso: 'GY',
    country_code: 328,
    idmc_short_name: 'Guyana',
    idmc_full_name: 'Guyana',
    name: 'Guyana',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [4.88732, -58.9398798968075],
    boundingbox: [1.1710017, -61.414905, 8.6038842, -56.4689543],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Guayana',
    idmc_short_name_fr: 'Â Guyana',
    idmc_short_name_ar: 'Â ØºÙØ§ÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'HTI',
    iso: 'HT',
    country_code: 332,
    idmc_short_name: 'Haiti',
    idmc_full_name: 'Haiti',
    name: 'Haiti',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.40665471391907, -72.828369140625],
    boundingbox: [17.9099291, -74.6575357, 20.2181368, -71.6221297],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'HaitÃ­',
    idmc_short_name_fr: 'Â HaÃ¯ti',
    idmc_short_name_ar: 'Â ÙØ§ÙØªÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'HND',
    iso: 'HN',
    country_code: 340,
    idmc_short_name: 'Honduras',
    idmc_full_name: 'Honduras',
    name: 'Honduras',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [15.0610686, -84.5978534],
    boundingbox: [12.9808485, -89.3568207, 17.619526, -82.1729621],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Honduras',
    idmc_short_name_fr: 'Â Honduras',
    idmc_short_name_ar: 'Â ÙÙØ¯ÙØ±Ø§Ø³',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'JAM',
    iso: 'JM',
    country_code: 388,
    idmc_short_name: 'Jamaica',
    idmc_full_name: 'Jamaica',
    name: 'Jamaica',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.1850507, -77.3947693],
    boundingbox: [16.5899443, -78.5782366, 18.7256394, -75.7541143],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Jamaica',
    idmc_short_name_fr: 'Â JamaÃ¯que',
    idmc_short_name_ar: 'Â Ø¬Ø§ÙØ§ÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'MEX',
    iso: 'MX',
    country_code: 484,
    idmc_short_name: 'Mexico',
    idmc_full_name: 'Mexico',
    name: 'Mexico',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [19.4326009, -99.1333416],
    boundingbox: [
      12.768946439455956,
      -118.2568359375,
      34.70549341022544,
      -84.6826171875,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'MÃ©xico',
    idmc_short_name_fr: 'Â Mexique',
    idmc_short_name_ar: 'Â Ø§ÙÙÙØ³ÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'NIC',
    iso: 'NI',
    country_code: 558,
    idmc_short_name: 'Nicaragua',
    idmc_full_name: 'Nicaragua',
    name: 'Nicaragua',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [12.3724928, -84.8700308],
    boundingbox: [10.7076565, -87.901532, 15.0331183, -82.6227023],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Nicaragua',
    idmc_short_name_fr: 'Â Nicaragua',
    idmc_short_name_ar: 'Â ÙÙÙØ§Ø±Ø§ØºÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'PAN',
    iso: 'PA',
    country_code: 591,
    idmc_short_name: 'Panama',
    idmc_full_name: 'Panama',
    name: 'Panama',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Central America',
    centroid: [8.3096067, -81.3066246],
    boundingbox: [7.0338679, -83.0517245, 9.8701757, -77.1393779],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'PanamÃ¡',
    idmc_short_name_fr: 'Â Panama',
    idmc_short_name_ar: 'Â Ø¨ÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'PRY',
    iso: 'PY',
    country_code: 600,
    idmc_short_name: 'Paraguay',
    idmc_full_name: 'Paraguay',
    name: 'Paraguay',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-23.3165935, -58.1693445],
    boundingbox: [-27.6063935, -62.6442036, -19.2876472, -54.258],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Paraguay',
    idmc_short_name_fr: 'Â Paraguay',
    idmc_short_name_ar: 'Â Ø¨Ø§Ø±Ø§ØºÙØ§Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'PER',
    iso: 'PE',
    country_code: 604,
    idmc_short_name: 'Peru',
    idmc_full_name: 'Peru',
    name: 'Peru',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-6.8699697, -75.0458515],
    boundingbox: [-20.1984472, -84.6356535, -0.0392818, -68.6519906],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'PerÃº',
    idmc_short_name_fr: 'Â PÃ©rou',
    idmc_short_name_ar: 'Â Ø¨ÙØ±Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'PRI',
    iso: 'PR',
    country_code: 630,
    idmc_short_name: 'Puerto Rico',
    idmc_full_name: 'Puerto Rico',
    name: 'Puerto Rico',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.22141715, -66.4132818505648],
    boundingbox: [17.9268695, -67.271492, 18.5159789, -65.5897525],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Puerto Rico',
    idmc_short_name_fr: 'Â Porto Rico',
    idmc_short_name_ar: 'Â Ø¨ÙØ±ØªÙØ±ÙÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'KNA',
    iso: 'KN',
    country_code: 659,
    idmc_short_name: 'St. Kitts and Nevis',
    idmc_full_name: 'Saint Kitts and Nevis',
    name: 'St. Kitts and Nevis',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [17.3462278, -62.7687277],
    boundingbox: [16.895, -63.051129, 17.6158146, -62.3303519],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San CristÃ³bal y Nieves',
    idmc_short_name_fr: 'Â Saint-Christophe-et-NiÃ©vÃ¨s',
    idmc_short_name_ar: 'Â Ø³Ø§ÙØª ÙÙØªØ³ ÙÙÙÙÙØ³',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'LCA',
    iso: 'LC',
    country_code: 662,
    idmc_short_name: 'St. Lucia',
    idmc_full_name: 'Saint Lucia',
    name: 'St. Lucia',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [13.8250489, -60.975036],
    boundingbox: [13.508, -61.2853867, 14.2725, -60.6669363],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Santa LucÃ­a',
    idmc_short_name_fr: 'Â Sainte-Lucie',
    idmc_short_name_ar: 'Â Ø³Ø§ÙØª ÙÙØ³ÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'VCT',
    iso: 'VC',
    country_code: 670,
    idmc_short_name: 'St. Vincent and the Grenadines',
    idmc_full_name: 'Saint Vincent and the Grenadines',
    name: 'St. Vincent and the Grenadines',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [12.90447, -61.2765569],
    boundingbox: [12.5166548, -61.6657471, 13.583, -60.9094146],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San Vicente y las Granadinas',
    idmc_short_name_fr: 'Â Saint-Vincent-et-les-Grenadines',
    idmc_short_name_ar: 'Â Ø³Ø§ÙØª ÙÙÙØ³ÙØª ÙØ§ÙØºØ±ÙÙØ§Ø¯ÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'MAF',
    iso: '',
    country_code: 663,
    idmc_short_name: 'St. Martin (French part)',
    idmc_full_name: 'Saint Martin (French Part)',
    name: 'St. Martin (French part)',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.0811, -63.0595],
    boundingbox: [17.8963535, -63.3605643, 18.1902778, -62.7644063],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San MartÃ­n',
    idmc_short_name_fr: 'Â Saint-Martin',
    idmc_short_name_ar: 'Â ØªØ¬ÙØ¹ Ø³Ø§Ù ÙØ§Ø±ØªÙÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'TTO',
    iso: 'TT',
    country_code: 780,
    idmc_short_name: 'Trinidad and Tobago',
    idmc_full_name: 'Trinidad and Tobago',
    name: 'Trinidad and Tobago',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [10.8677845, -60.9821067],
    boundingbox: [9.8732106, -62.083056, 11.5628372, -60.2895848],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Trinidad y Tobago',
    idmc_short_name_fr: 'Â TrinitÃ©-et-Tobago',
    idmc_short_name_ar: 'Â ØªØ±ÙÙÙØ¯Ø§Ø¯ ÙØªÙØ¨Ø§ØºÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'TCA',
    iso: 'TC',
    country_code: 796,
    idmc_short_name: 'Turks and Caicos Islands',
    idmc_full_name: 'Turks and Caicos Islands',
    name: 'Turks and Caicos Islands',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [21.7214683, -71.6201783],
    boundingbox: [20.9553418, -72.6799046, 22.1630989, -70.8643591],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas Turcas y Caicos',
    idmc_short_name_fr: 'Â Ãles Turques-et-CaÃ¯ques',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± ØªÙØ±ÙØ³ ÙÙØ§ÙÙÙØ³',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'SXM',
    iso: '',
    country_code: 534,
    idmc_short_name: 'Sint Maarten (Dutch part)',
    idmc_full_name: 'Sint Maarten (Dutch part)',
    name: 'Sint Maarten (Dutch part)',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.0397, -63.0631],
    boundingbox: [17.806209, -63.2677941, 18.0639862, -62.949445],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'San MartÃ­n',
    idmc_short_name_fr: 'Â Saint-Martin',
    idmc_short_name_ar: 'Â Ø³ÙÙØª ÙØ§Ø±ØªÙ',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'URY',
    iso: 'UY',
    country_code: 858,
    idmc_short_name: 'Uruguay',
    idmc_full_name: 'Uruguay',
    name: 'Uruguay',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [-32.8755548, -56.0201525],
    boundingbox: [-35.7824481, -58.4948438, -30.0853962, -53.0755833],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Uruguay',
    idmc_short_name_fr: 'Â Uruguay',
    idmc_short_name_ar: 'Â Ø§ÙØ£ÙØ±ÙØºÙØ§Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'VIR',
    iso: 'VI',
    country_code: 850,
    idmc_short_name: 'Virgin Islands',
    idmc_full_name: 'United States Virgin Islands',
    name: 'Virgin Islands (U.S.)',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [17.789187, -64.7080574],
    boundingbox: [17.623468, -65.159094, 18.464984, -64.512674],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas VÃ­rgenes de los Estados Unidos de AmÃ©rica',
    idmc_short_name_fr: 'Â Ãles Vierges des Ãtats-Unis',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø§ÙØ¹Ø°Ø±Ø§Ø¡ Ø§ÙØ£ÙØ±ÙÙÙØ©',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'AIA',
    iso: 'AI',
    country_code: 660,
    idmc_short_name: 'Anguilla',
    idmc_full_name: 'Anguilla',
    name: 'Anguilla',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.1954947, -63.0750234],
    boundingbox: [18.0615454, -63.6391992, 18.7951194, -62.7125449],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Anguila',
    idmc_short_name_fr: 'Â Anguilla',
    idmc_short_name_ar: 'Â Ø£ÙØºÙÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'VGB',
    iso: 'VG',
    country_code: 92,
    idmc_short_name: 'British Virgin Islands',
    idmc_full_name: 'British Virgin Islands',
    name: 'Virgin Islands (British)',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'Caribbean',
    centroid: [18.4024395, -64.5661642],
    boundingbox: [18.1055311, -64.9559611, 18.9503802, -64.0597294],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas VÃ­rgenes BritÃ¡nicas',
    idmc_short_name_fr: 'Â Ãles Vierges britanniques',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø§ÙØ¹Ø°Ø±Ø§Ø¡ Ø§ÙØ¨Ø±ÙØ·Ø§ÙÙØ©',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'VEN',
    iso: 'VE',
    country_code: 862,
    idmc_short_name: 'Venezuela',
    idmc_full_name: 'Venezuela (Bolivarian Republic of)',
    name: 'Venezuela, RB',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [7.12479, -66.1536],
    boundingbox: [
      -0.32958802605356885,
      -74.2236328125,
      13.068776734357694,
      -58.84277343749999,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Venezuela',
    idmc_short_name_fr: 'Â Venezuela',
    idmc_short_name_ar: 'Â ÙÙØ²ÙÙÙØ§',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'SUR',
    iso: 'SR',
    country_code: 740,
    idmc_short_name: 'Suriname',
    idmc_full_name: 'Suriname',
    name: 'Suriname',
    geographical_group: 'Latin America and the Caribbean',
    region: 'Americas',
    sub_region: 'South America',
    centroid: [4.1413025, -56.0771187],
    boundingbox: [1.8312802, -58.070833, 6.225, -53.8433358],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Surinam',
    idmc_short_name_fr: 'Â Suriname',
    idmc_short_name_ar: 'Â Ø³ÙØ±ÙÙØ§Ù',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'SRB',
    iso: 'RS',
    country_code: 688,
    idmc_short_name: 'Serbia',
    idmc_full_name: 'Serbia',
    name: 'Serbia',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [44.1534121, 20.55144],
    boundingbox: [42.2322435, 18.8142875, 46.1900524, 23.006309],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Serbia y Montenegro',
    idmc_short_name_fr: 'Â Serbie',
    idmc_short_name_ar: 'Â ØµØ±Ø¨ÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'SGP',
    iso: 'SG',
    country_code: 702,
    idmc_short_name: 'Singapore',
    idmc_full_name: 'Singapore',
    name: 'Singapore',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [1.2904753, 103.8520359],
    boundingbox: [1.1304753, 103.6920359, 1.4504753, 104.0120359],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Singapur',
    idmc_short_name_fr: 'Â Singapour',
    idmc_short_name_ar: 'Â Ø³ÙØºØ§ÙÙØ±Ø©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'SEN',
    iso: 'SN',
    country_code: 686,
    idmc_short_name: 'Senegal',
    idmc_full_name: 'Senegal',
    name: 'Senegal',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [15.14636929963884, -13.645019531249998],
    boundingbox: [12.2372838, -17.7862419, 16.6919712, -11.3458996],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'West',
    idmc_short_name_es: 'Senegal',
    idmc_short_name_fr: 'Â SÃ©nÃ©gal',
    idmc_short_name_ar: 'Â Ø§ÙØ³ÙØºØ§Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'RWA',
    iso: 'RW',
    country_code: 646,
    idmc_short_name: 'Rwanda',
    idmc_full_name: 'Rwanda',
    name: 'Rwanda',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-1.625758360412755, 30.3936767578125],
    boundingbox: [-2.8389804, 28.8617546, -1.0474083, 30.8990738],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'East',
    idmc_short_name_es: 'Ruanda',
    idmc_short_name_fr: 'Â Rwanda',
    idmc_short_name_ar: 'Â Ø±ÙØ§ÙØ¯Ø§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SYC',
    iso: 'SC',
    country_code: 690,
    idmc_short_name: 'Seychelles',
    idmc_full_name: 'Seychelles',
    name: 'Seychelles',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-4.6574977, 55.4540146],
    boundingbox: [-10.4649258, 45.9988759, -3.512, 56.4979396],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'East',
    idmc_short_name_es: 'Seychelles',
    idmc_short_name_fr: 'Â Seychelles',
    idmc_short_name_ar: 'Â Ø³ÙØ´Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'NGA',
    iso: 'NG',
    country_code: 566,
    idmc_short_name: 'Nigeria',
    idmc_full_name: 'Nigeria',
    name: 'Nigeria',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [9.6000359, 7.9999721],
    boundingbox: [4.0690959, 2.676932, 13.885645, 14.678014],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Nigeria',
    idmc_short_name_fr: 'Â Nigeria',
    idmc_short_name_ar: 'Â ÙÙØ¬ÙØ±ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SLE',
    iso: 'SL',
    country_code: 694,
    idmc_short_name: 'Sierra Leone',
    idmc_full_name: 'Sierra Leone',
    name: 'Sierra Leone',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [8.6400349, -11.8400269],
    boundingbox: [6.755, -13.5003389, 9.999973, -10.271683],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Sierra Leona',
    idmc_short_name_fr: 'Â Sierra Leone',
    idmc_short_name_ar: 'Â Ø³ÙØ±Ø§ÙÙÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SVK',
    iso: 'SK',
    country_code: 703,
    idmc_short_name: 'Slovakia',
    idmc_full_name: 'Slovakia',
    name: 'Slovak Republic',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [48.7411522, 19.4528646],
    boundingbox: [47.7314286, 16.8331891, 49.6138162, 22.56571],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Eslovaquia',
    idmc_short_name_fr: 'Â Slovaquie',
    idmc_short_name_ar: 'Â Ø³ÙÙÙØ§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'SVN',
    iso: 'SI',
    country_code: 705,
    idmc_short_name: 'Slovenia',
    idmc_full_name: 'Slovenia',
    name: 'Slovenia',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [45.8133113, 14.4808369],
    boundingbox: [45.4214242, 13.3754696, 46.8766816, 16.5967702],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Eslovenia',
    idmc_short_name_fr: 'Â SlovÃ©nie',
    idmc_short_name_ar: 'Â Ø³ÙÙÙÙÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'SLB',
    iso: 'SB',
    country_code: 90,
    idmc_short_name: 'Solomon Islands',
    idmc_full_name: 'Solomon Islands',
    name: 'Solomon Islands',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Melanesia',
    centroid: [-9.7354344, 162.8288542],
    boundingbox: [-13.2424298, 155.3190556, -4.81085, 170.3964667],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Islas SolomÃ³n',
    idmc_short_name_fr: 'Â Salomon',
    idmc_short_name_ar: 'Â Ø¬Ø²Ø± Ø³ÙÙÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'ESP',
    iso: 'ES',
    country_code: 724,
    idmc_short_name: 'Spain',
    idmc_full_name: 'Spain',
    name: 'Spain',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Southern Europe',
    centroid: [40.0028028, -4.003104],
    boundingbox: [
      35.42486791930558,
      -10.5029296875,
      44.276671273775186,
      4.130859375,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'EspaÃ±a',
    idmc_short_name_fr: 'Â Espagne',
    idmc_short_name_ar: 'Â Ø¥Ø³Ø¨Ø§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'LKA',
    iso: 'LK',
    country_code: 144,
    idmc_short_name: 'Sri Lanka',
    idmc_full_name: 'Sri Lanka',
    name: 'Sri Lanka',
    geographical_group: 'South Asia',
    region: 'Asia',
    sub_region: 'Southern Asia',
    centroid: [7.878, 80.7038245875],
    boundingbox: [5.719, 79.3959205, 10.035, 82.0810141],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Sri Lanka',
    idmc_short_name_fr: 'Â Sri Lanka',
    idmc_short_name_ar: 'Â Ø³Ø±ÙÙØ§ÙÙØ§',
    geographical_group_grid: 'South Asia',
  },
  {
    iso3: 'SWE',
    iso: 'SE',
    country_code: 752,
    idmc_short_name: 'Sweden',
    idmc_full_name: 'Sweden',
    name: 'Sweden',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [59.6749712, 14.5208584],
    boundingbox: [55.1331192, 10.5930952, 69.0599699, 24.1776819],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Suecia',
    idmc_short_name_fr: 'Â SuÃ¨de',
    idmc_short_name_ar: 'Â Ø§ÙØ³ÙÙØ¯',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'CHE',
    iso: 'CH',
    country_code: 756,
    idmc_short_name: 'Switzerland',
    idmc_full_name: 'Switzerland',
    name: 'Switzerland',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Western Europe',
    centroid: [46.7985624, 8.2319736],
    boundingbox: [45.817995, 5.9559113, 47.8084648, 10.4922941],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Suiza',
    idmc_short_name_fr: 'Â Suisse',
    idmc_short_name_ar: 'Â Ø³ÙÙØ³Ø±Ø§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'SYR',
    iso: 'SY',
    country_code: 760,
    idmc_short_name: 'Syria',
    idmc_full_name: 'Syrian Arab Republic',
    name: 'Syrian Arab Republic',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [35.41591492345623, 39.7705078125],
    boundingbox: [
      31.793555207271424,
      35.09033203125,
      37.67512527892127,
      42.879638671875,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Siria',
    idmc_short_name_fr: 'Â Syrie',
    idmc_short_name_ar: 'Â Ø³ÙØ±ÙØ§',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'TWN',
    iso: 'TW',
    country_code: 158,
    idmc_short_name: 'Taiwan, China',
    idmc_full_name: 'Taiwan (Province of China)',
    name: 'Taiwan, China',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'Eastern Asia',
    centroid: [25.12525115, 121.737633279954],
    boundingbox: [25.1249353, 121.7372907, 25.1256941, 121.7380194],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'TaiwÃ¡n',
    idmc_short_name_fr: 'Â TaÃ¯wanÂ / (RÃ©publique de Chine (TaÃ¯wan))',
    idmc_short_name_ar: 'Â ØªØ§ÙÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'TJK',
    iso: 'TJ',
    country_code: 762,
    idmc_short_name: 'Tajikistan',
    idmc_full_name: 'Tajikistan',
    name: 'Tajikistan',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Central Asia',
    centroid: [38.6281733, 70.8156541],
    boundingbox: [36.6711153, 67.3332775, 41.0450935, 75.1539563],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'TayikistÃ¡n',
    idmc_short_name_fr: 'Â Tadjikistan',
    idmc_short_name_ar: 'Â Ø·Ø§Ø¬ÙÙØ³ØªØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'THA',
    iso: 'TH',
    country_code: 764,
    idmc_short_name: 'Thailand',
    idmc_full_name: 'Thailand',
    name: 'Thailand',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [14.8971921, 100.83273],
    boundingbox: [5.612851, 97.3438072, 20.4648337, 105.636812],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Tailandia',
    idmc_short_name_fr: 'Â ThaÃ¯lande',
    idmc_short_name_ar: 'Â ØªØ§ÙÙØ§ÙØ¯',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'TLS',
    iso: 'TL',
    country_code: 626,
    idmc_short_name: 'Timor-Leste',
    idmc_full_name: 'Timor-Leste',
    name: 'Timor-Leste',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [-8.5151979, 125.8375756],
    boundingbox: [-9.5642775, 124.0415703, -8.0895459, 127.5335392],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Timor-Leste',
    idmc_short_name_fr: 'Â Timor oriental',
    idmc_short_name_ar: 'Â ØªÙÙÙØ± Ø§ÙØ´Ø±ÙÙØ©',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'TON',
    iso: 'TO',
    country_code: 776,
    idmc_short_name: 'Tonga',
    idmc_full_name: 'Tonga',
    name: 'Tonga',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Polynesia',
    centroid: [-19.9160819, -175.2026424],
    boundingbox: [-24.1034499, -179.3866055, -15.3655722, -173.5295458],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Tonga',
    idmc_short_name_fr: 'Â Tonga',
    idmc_short_name_ar: 'Â ØªÙÙØºØ§',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'TUR',
    iso: 'TR',
    country_code: 792,
    idmc_short_name: 'Turkey',
    idmc_full_name: 'Turkey',
    name: 'Turkey',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [38.9597594, 34.9249653],
    boundingbox: [35.8076804, 25.6212891, 42.297, 44.8176638],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'TurquÃ­a',
    idmc_short_name_fr: 'Â Turquie',
    idmc_short_name_ar: 'Â ØªØ±ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'TKM',
    iso: 'TM',
    country_code: 795,
    idmc_short_name: 'Turkmenistan',
    idmc_full_name: 'Turkmenistan',
    name: 'Turkmenistan',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Central Asia',
    centroid: [39.3763807, 59.3924609],
    boundingbox: [35.129093, 52.335076, 42.7975571, 66.684303],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'TurkmenistÃ¡n',
    idmc_short_name_fr: 'Â TurkmÃ©nistan',
    idmc_short_name_ar: 'Â ØªØ±ÙÙØ§ÙØ³ØªØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'TUV',
    iso: 'TV',
    country_code: 798,
    idmc_short_name: 'Tuvalu',
    idmc_full_name: 'Tuvalu',
    name: 'Tuvalu',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Polynesia',
    centroid: [-7.768959, 178.1167698],
    boundingbox: [-10.9939389, -180, -5.4369611, 180],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Tuvalu',
    idmc_short_name_fr: 'Â Tuvalu',
    idmc_short_name_ar: 'Â ØªÙÙØ§ÙÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'UKR',
    iso: 'UA',
    country_code: 804,
    idmc_short_name: 'Ukraine',
    idmc_full_name: 'Ukraine',
    name: 'Ukraine',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Eastern Europe',
    centroid: [49.4871968, 31.2718321],
    boundingbox: [44.184598, 22.137059, 52.3791473, 40.2341581],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Ucrania',
    idmc_short_name_fr: 'Â Ukraine',
    idmc_short_name_ar: 'Â Ø£ÙÙØ±Ø§ÙÙØ§',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'ARE',
    iso: 'AE',
    country_code: 784,
    idmc_short_name: 'United Arab Emirates',
    idmc_full_name: 'United Arab Emirates',
    name: 'United Arab Emirates',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [24.0002488, 53.9994829],
    boundingbox: [22.6316214, 51.4160714, 26.1517219, 56.6024458],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Emiratos Ãrabes Unidos',
    idmc_short_name_fr: 'Â Ãmirats arabes unis',
    idmc_short_name_ar: 'Â Ø§ÙØ¥ÙØ§Ø±Ø§Øª Ø§ÙØ¹Ø±Ø¨ÙØ© Ø§ÙÙØªØ­Ø¯Ø©',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'UZB',
    iso: 'UZ',
    country_code: 860,
    idmc_short_name: 'Uzbekistan',
    idmc_full_name: 'Uzbekistan',
    name: 'Uzbekistan',
    geographical_group: 'Europe and Central Asia',
    region: 'Asia',
    sub_region: 'Central Asia',
    centroid: [41.32373, 63.9528098],
    boundingbox: [37.1772144, 55.9977865, 45.590118, 73.1397362],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'UzbekistÃ¡n',
    idmc_short_name_fr: 'Â OuzbÃ©kistan',
    idmc_short_name_ar: 'Â Ø£ÙØ²Ø¨ÙØ³ØªØ§Ù',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'VUT',
    iso: 'VU',
    country_code: 548,
    idmc_short_name: 'Vanuatu',
    idmc_full_name: 'Vanuatu',
    name: 'Vanuatu',
    geographical_group: 'East Asia and Pacific',
    region: 'Oceania',
    sub_region: 'Melanesia',
    centroid: [-16.5255069, 168.1069154],
    boundingbox: [-20.4627425, 166.3355255, -12.8713777, 170.449982],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Vanuatu',
    idmc_short_name_fr: 'Â Vanuatu',
    idmc_short_name_ar: 'Â ÙØ§ÙÙØ§ØªÙ',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'ZAF',
    iso: 'ZA',
    country_code: 710,
    idmc_short_name: 'South Africa',
    idmc_full_name: 'South Africa',
    name: 'South Africa',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Southern Africa',
    centroid: [-30.637912028341113, 23.37890625],
    boundingbox: [
      -35.406960932702,
      15.1171875,
      -20.797201434306984,
      34.32128906249999,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'South',
    idmc_short_name_es: 'SudÃ¡frica',
    idmc_short_name_fr: 'Â Afrique du Sud',
    idmc_short_name_ar: 'Â Ø¬ÙÙØ¨ Ø£ÙØ±ÙÙÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'TUN',
    iso: 'TN',
    country_code: 788,
    idmc_short_name: 'Tunisia',
    idmc_full_name: 'Tunisia',
    name: 'Tunisia',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: 'Northern Africa',
    centroid: [33.8439408, 9.400138],
    boundingbox: [30.230236, 7.5219807, 37.7612052, 11.8801133],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'North',
    idmc_short_name_es: 'TÃºnez',
    idmc_short_name_fr: 'Â Tunisie',
    idmc_short_name_ar: 'Â ØªÙÙØ³',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'TGO',
    iso: 'TG',
    country_code: 768,
    idmc_short_name: 'Togo',
    idmc_full_name: 'Togo',
    name: 'Togo',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [8.7800265, 1.0199765],
    boundingbox: [5.926547, -0.1439719, 11.139497, 1.8087605],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'Togo',
    idmc_short_name_fr: 'Â Togo',
    idmc_short_name_ar: 'Â ØªÙØºÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SOM',
    iso: 'SO',
    country_code: 706,
    idmc_short_name: 'Somalia',
    idmc_full_name: 'Somalia',
    name: 'Somalia',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [8.3676771, 49.083416],
    boundingbox: [-1.8031969, 40.98918, 12.1889121, 51.6177696],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'Somalia',
    idmc_short_name_fr: 'Â Somalie',
    idmc_short_name_ar: 'Â Ø§ÙØµÙÙØ§Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'UGA',
    iso: 'UG',
    country_code: 800,
    idmc_short_name: 'Uganda',
    idmc_full_name: 'Uganda',
    name: 'Uganda',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [1.5333554, 32.2166578],
    boundingbox: [-1.4823179, 29.573433, 4.2340766, 35.000308],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'East',
    idmc_short_name_es: 'Uganda',
    idmc_short_name_fr: 'Â Ouganda',
    idmc_short_name_ar: 'Â Ø£ÙØºÙØ¯Ø§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SWZ',
    iso: 'SZ',
    country_code: 748,
    idmc_short_name: 'Eswatini',
    idmc_full_name: 'The Kingdom of Eswatini',
    name: 'Eswatini',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Southern Africa',
    centroid: [-26.5624806, 31.3991317],
    boundingbox: [-27.3175201, 30.7908, -25.71876, 32.1349923],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'South',
    idmc_short_name_es: 'Eswatini',
    idmc_short_name_fr: 'Eswatini',
    idmc_short_name_ar: 'Â Ø³ÙØ§Ø²ÙÙØ§ÙØ¯',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'YEM',
    iso: 'YE',
    country_code: 887,
    idmc_short_name: 'Yemen',
    idmc_full_name: 'Yemen',
    name: 'Yemen, Rep.',
    geographical_group: 'Middle East and North Africa',
    region: 'Asia',
    sub_region: 'Western Asia',
    centroid: [16.3471243, 47.8915271],
    boundingbox: [11.9084802, 41.60825, 19, 54.7389375],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Yemen',
    idmc_short_name_fr: 'Â YÃ©men',
    idmc_short_name_ar: 'Â Ø§ÙÙÙÙ',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'VNM',
    iso: 'VN',
    country_code: 704,
    idmc_short_name: 'Viet Nam',
    idmc_full_name: 'Viet Nam',
    name: 'Vietnam',
    geographical_group: 'East Asia and Pacific',
    region: 'Asia',
    sub_region: 'South-Eastern Asia',
    centroid: [13.2904027, 108.4265113],
    boundingbox: [8.1790665, 102.14441, 23.393395, 114.3337595],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Vietnam',
    idmc_short_name_fr: 'Â ViÃªt Nam',
    idmc_short_name_ar: 'Â ÙÙØªÙØ§Ù',
    geographical_group_grid: 'East Asia and Pacific',
  },
  {
    iso3: 'GBR',
    iso: 'GB',
    country_code: 826,
    idmc_short_name: 'United Kingdom',
    idmc_full_name: 'United Kingdom of Great Britain and Northern Ireland',
    name: 'United Kingdom',
    geographical_group: 'Europe and Central Asia',
    region: 'Europe',
    sub_region: 'Northern Europe',
    centroid: [54.1389, -2.87016],
    boundingbox: [
      49.210420445650286,
      -8.8330078125,
      61.41775026352097,
      2.724609375,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Reino Unido',
    idmc_short_name_fr: 'Â Royaume-Uni',
    idmc_short_name_ar: 'Â Ø§ÙÙÙÙÙØ© Ø§ÙÙØªØ­Ø¯Ø©',
    geographical_group_grid: 'Europe and Central Asia',
  },
  {
    iso3: 'USA',
    iso: 'US',
    country_code: 840,
    idmc_short_name: 'United States',
    idmc_full_name: 'United States of America',
    name: 'United States',
    geographical_group: 'North America',
    region: 'Americas',
    sub_region: 'Northern America',
    centroid: [39.7837304, -100.4458825],
    boundingbox: [
      21.94304553343818,
      -128.14453125,
      52.26815737376817,
      -62.9296875,
    ],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: '',
    idmc_short_name_es: 'Estados Unidos de AmÃ©rica',
    idmc_short_name_fr: 'Â Ãtats-Unis',
    idmc_short_name_ar: 'Â Ø§ÙÙÙØ§ÙØ§Øª Ø§ÙÙØªØ­Ø¯Ø©',
    geographical_group_grid: 'Americas',
  },
  {
    iso3: 'LBY',
    iso: 'LY',
    country_code: 434,
    idmc_short_name: 'Libya',
    idmc_full_name: 'Libya',
    name: 'Libya',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: 'Northern Africa',
    centroid: [26.8234472, 18.1236723],
    boundingbox: [19.5008138, 9.391081, 33.3545898, 25.3770629],
    kampala_signed: 'f',
    kampala_ratified: 'f',
    sub_region_au: 'North',
    idmc_short_name_es: 'Libia',
    idmc_short_name_fr: 'Â Libye',
    idmc_short_name_ar: 'Â ÙÙØ¨ÙØ§',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'CMR',
    iso: 'CM',
    country_code: 120,
    idmc_short_name: 'Cameroon',
    idmc_full_name: 'Cameroon',
    name: 'Cameroon',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [4.6125522, 13.1535811],
    boundingbox: [1.6546659, 8.3822176, 13.083333, 16.1921476],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'Central',
    idmc_short_name_es: 'CamerÃºn',
    idmc_short_name_fr: 'Â Cameroun',
    idmc_short_name_ar: 'Â Ø§ÙÙØ§ÙÙØ±ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'COD',
    iso: 'CD',
    country_code: 180,
    idmc_short_name: 'Dem. Rep. Congo',
    idmc_full_name: 'Democratic Republic of the Congo',
    name: 'Congo, Dem. Rep.',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [-2.88027, 23.6598],
    boundingbox: [
      -14.541049898060388,
      11.22802734375,
      6.227933930268672,
      32.16796875,
    ],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'Central',
    idmc_short_name_es: 'RepÃºblica DemocrÃ¡tica del Congo',
    idmc_short_name_fr: 'Â RÃ©publique dÃ©mocratique du Congo',
    idmc_short_name_ar: 'Â Ø¬ÙÙÙØ±ÙØ© Ø§ÙÙÙÙØºÙ Ø§ÙØ¯ÙÙÙØ±Ø§Ø·ÙØ©',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'GAB',
    iso: 'GA',
    country_code: 266,
    idmc_short_name: 'Gabon',
    idmc_full_name: 'Gabon',
    name: 'Gabon',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [-0.8999695, 11.6899699],
    boundingbox: [-4.1012261, 8.5002246, 2.3182171, 14.539444],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'Central',
    idmc_short_name_es: 'GabÃ³n',
    idmc_short_name_fr: 'Â Gabon',
    idmc_short_name_ar: 'Â Ø§ÙØºØ§Ø¨ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'BDI',
    iso: 'BI',
    country_code: 108,
    idmc_short_name: 'Burundi',
    idmc_full_name: 'Burundi',
    name: 'Burundi',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-3.7875217118824227, 29.827880859375],
    boundingbox: [-4.4693155, 29.0007401, -2.3096796, 30.8498462],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'Central',
    idmc_short_name_es: 'Burundi',
    idmc_short_name_fr: 'Â Burundi',
    idmc_short_name_ar: 'Â Ø¨ÙØ±ÙÙØ¯Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'NER',
    iso: 'NE',
    country_code: 562,
    idmc_short_name: 'Niger',
    idmc_full_name: 'Niger',
    name: 'Niger',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [17.7356214, 9.3238432],
    boundingbox: [11.693756, 0.1689653, 23.517178, 15.996667],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'West',
    idmc_short_name_es: 'NÃ­ger',
    idmc_short_name_fr: 'Â Niger',
    idmc_short_name_ar: 'Â Ø§ÙÙÙØ¬Ø±',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SDN',
    iso: 'SD',
    country_code: 729,
    idmc_short_name: 'Sudan',
    idmc_full_name: 'Sudan',
    name: 'Sudan',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Northern Africa',
    centroid: [14.5844444, 29.4917691],
    boundingbox: [8.685278, 21.8145046, 22.224918, 39.0576252],
    kampala_signed: 'f',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'SudÃ¡n',
    idmc_short_name_fr: 'Â Soudan',
    idmc_short_name_ar: 'Â Ø§ÙØ³ÙØ¯Ø§Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'EGY',
    iso: 'EG',
    country_code: 818,
    idmc_short_name: 'Egypt',
    idmc_full_name: 'Egypt',
    name: 'Egypt, Arab Rep.',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: 'Northern Africa',
    centroid: [26.2540493, 29.2675469],
    boundingbox: [21.9999975, 24.6499112, 31.8330854, 37.1153517],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'North',
    idmc_short_name_es: 'Egipto',
    idmc_short_name_fr: 'Â Ãgypte',
    idmc_short_name_ar: 'Â ÙØµØ±',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'DZA',
    iso: 'DZ',
    country_code: 12,
    idmc_short_name: 'Algeria',
    idmc_full_name: 'Algeria',
    name: 'Algeria',
    geographical_group: 'Middle East and North Africa',
    region: 'Africa',
    sub_region: 'Northern Africa',
    centroid: [28.0000272, 2.9999825],
    boundingbox: [18.968147, -8.668908, 37.2962055, 11.997337],
    kampala_signed: '',
    kampala_ratified: '',
    sub_region_au: 'North',
    idmc_short_name_es: 'Argel',
    idmc_short_name_fr: 'Â AlgÃ©rie',
    idmc_short_name_ar: 'Â Ø§ÙØ¬Ø²Ø§Ø¦Ø±',
    geographical_group_grid: 'Middle East and North Africa',
  },
  {
    iso3: 'STP',
    iso: 'ST',
    country_code: 678,
    idmc_short_name: 'SÃ£o TomÃ© and Principe',
    idmc_full_name: 'Sao Tome and Principe',
    name: 'Sao Tome and Principe',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Middle Africa',
    centroid: [0.8875498, 6.9648718],
    boundingbox: [-0.2135137, 6.260642, 1.9257601, 7.6704783],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'Central',
    idmc_short_name_es: 'Santo TomÃ© y PrÃ­ncipe',
    idmc_short_name_fr: 'Â Sao TomÃ©-et-Principe',
    idmc_short_name_ar: 'Â Ø³Ø§Ù ØªÙÙÙ ÙØ¨Ø±ÙÙØ³ÙØ¨',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'ZWE',
    iso: 'ZW',
    country_code: 716,
    idmc_short_name: 'Zimbabwe',
    idmc_full_name: 'Zimbabwe',
    name: 'Zimbabwe',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-18.4554963, 29.7468414],
    boundingbox: [-22.4241096, 25.2373, -15.6097033, 33.0683413],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'South',
    idmc_short_name_es: 'Zimbabwe',
    idmc_short_name_fr: 'Â Zimbabwe',
    idmc_short_name_ar: 'Â Ø²ÙÙØ¨Ø§Ø¨ÙÙ',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'SSD',
    iso: 'SS',
    country_code: 728,
    idmc_short_name: 'South Sudan',
    idmc_full_name: 'South Sudan',
    name: 'South Sudan',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [6.991859181483692, 30.73974609375],
    boundingbox: [3.48898, 23.447778, 12.236389, 35.948997],
    kampala_signed: 't',
    kampala_ratified: 'f',
    sub_region_au: 'East',
    idmc_short_name_es: 'SudÃ¡n del Sur',
    idmc_short_name_fr: 'Â Soudan du Sud',
    idmc_short_name_ar: 'Â Ø¬ÙÙØ¨ Ø§ÙØ³ÙØ¯Ø§Ù',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    iso3: 'ZMB',
    iso: 'ZM',
    country_code: 894,
    idmc_short_name: 'Zambia',
    idmc_full_name: 'Zambia',
    name: 'Zambia',
    geographical_group: 'Sub-Saharan Africa',
    region: 'Africa',
    sub_region: 'Eastern Africa',
    centroid: [-14.5186239, 27.5599164],
    boundingbox: [-18.0766965, 21.9993509, -8.2712822, 33.7025],
    kampala_signed: 't',
    kampala_ratified: 't',
    sub_region_au: 'South',
    idmc_short_name_es: 'Zambia',
    idmc_short_name_fr: 'Â Zambie',
    idmc_short_name_ar: 'Â Ø²Ø§ÙØ¨ÙØ§',
    geographical_group_grid: 'Sub-Saharan Africa',
  },
  {
    comment:
      'Added manually by Eric and Iva on 16 june 2019 since Western Sahara was not present in IDMC data',
    iso: 'EH',
    idmc_short_name: 'Western Sahara',
    idmc_full_name: 'Western Sahara',
    name: 'Western Sahara',
    geographical_group: 'Western Sahara',
    region: 'Africa',
    sub_region: 'Western Africa',
    centroid: [23.483400654325642, -12.930908203125],
    boundingbox: [
      20.20034600649375,
      -17.633056640625,
      28.159189634046708,
      -8.19580078125,
    ],
  },
];
